$ ->
    # console.log 'utlity js loaded now'

    window.utility =

        setTimeout: (delay, callback, params)->
            return setTimeout ->
                callback(params)
            , delay

        setInterval: (delay, callback, params)->
            return setInterval ->
                callback(params)
            , delay

        decodeHtml: (html)->
            txt = $('<textarea>').html(html)
            val = txt.val()
            txt.remove()
            return val

        prepVar: (val)->
            val = val.replace(/^\s+|\s+$/g,'')
            val = this.decodeHtml val
            return val

        focus: ($input)->
            $input.trigger 'focus'
            tmpStr = $input.val()
            $input.val('')
            $input.val(tmpStr)

        getQueryVars: ->
            parts = window.location.search.substr(1).split('&')
            data = {}
            unless parts[0] == ""
                for part in parts
                    x = part.split '='
                    key = decodeURIComponent(x[0].replace(/\+/g, " "))
                    value = decodeURIComponent(x[1].replace(/\+/g, " "))
                    data[key] = value or ""

            return data

        setQueryVars: (data)->
            output = []
            for k, v of data
                output.push k.replace(/\s/g, "+") + "=" + v.replace(/\s/g, "+")
            return "?" + output.join('&')

        formatDuration: (ms)->
            clock = []
            hours = Math.floor(ms / 3600000)
            minutes = Math.floor((ms % 3600000) / 60000)
            seconds = Math.floor(((ms % 360000) % 60000) / 1000)
            if hours
                clock.push hours
            if hours or minutes
                if hours and minutes < 10
                    clock.push "0" + minutes
                else 
                    clock.push minutes
            if hours or minutes or seconds
                if seconds < 10
                    clock.push "0" + seconds
                else
                    clock.push seconds
            time = clock.join(':')
            return time

        countdownClock: ($el, ms, callback)->
            endTime = new Date().getTime() + parseInt ms
            timer = setInterval ->
                remainingTime = endTime - new Date().getTime()
                if remainingTime > 1000
                    $el.text utility.formatDuration remainingTime
                else
                    clearInterval timer
                    callback() if callback
            , 1000

        numberInputOnly : (input,callback)->
            input.on 'keydown', (e)->
                # backspace, delete, tab, escape, enter, ctrl+A
                editKey = e.keyCode in [46, 8, 9, 27, 13, 110]
                # Allow: Ctrl+A
                control_a = e.keyCode == 65 and e.ctrlKey == true
                # number keys AND keys on a number pad
                numberKey = e.keyCode >= parseInt(e.originalEvent.keyIdentifier.substring(2),16) > 47 and parseInt(e.originalEvent.keyIdentifier.substring(2),16) < 58 and e.shiftKey == false
                # Allow: Ctrl+A
                control_a = e.keyCode == 65 and e.ctrlKey == true
                # Allow: home, end, left, right
                navKey = e.keyCode >= 35 and e.keyCode <= 39
                unless editKey or control_a or numberKey or navKey
                    e.preventDefault()

            input.on 'keyup', (e)->
                if callback
                    callback()

            input.on 'blur', (e)->
                if input.val() == ''
                    input.val('0')

        makeEllipse: ($els)->
            doEllipse = ->
                #console.log "doing Elipses"
                $els.each ->
                    string = $(this).attr('fullText')
                    if typeof(string) == 'undefined'
                        string = $(this).text()
                        $(this).attr('fullText',string)
                    words = string.split(' ')
                    $span = $('<span></span>')
                    $span.css 'display', 'block'
                    $span.html string
                    $(this).html $span
                    parent_height = $(this).innerHeight()
                    height = $span.outerHeight()
                    # console.log $(this), height, parent_height, string
                    while words.length && height>parent_height
                        words.pop()
                        $span.text words.join(' ') + " ..."
                        height = $span.height()
                        
            doEllipse()
            timer = null
            $(window).on 'resize', ->
                if timer
                    clearTimeout timer
                timer = setTimeout -> 
                    doEllipse()
                , 100

        getCsrfToken: ->
            # Get CSRF token from any form on the page
            tokenName = $('input[name^="csrf_"]').attr('name')
            tokenValue = $('input[name^="csrf_"]').val()
            if tokenName and tokenValue
                token = {}
                token[tokenName] = tokenValue
                return token
            return {}

        serverValidateField: ($form, fieldsObj)->
            valid = true
            firstFound = false
            $form.find('[name]').each ->
                $label = $(this).parent('label')
                $label.find('> small').remove()
                name = $(this).attr('name')
                if fieldsObj[name]
                    unless firstFound
                        utility.focus $(this)
                        firstFound = true
                    valid = false
                    $label.append $('<small>').text fieldsObj[name]

            return valid

        caffelliServerValidateField: ($form, fieldsObj) ->
            # Guard against a missing field-errors object. Some server failure
            # responses return data = [] with no user_errors (e.g. brute-force
            # lockout and CSRF failures in Login::auth_ajax), so callers pass
            # `undefined` here. Without this, the first [name] field deref below
            # (fieldsObj[name]) throws "Cannot read properties of undefined
            # (reading '<first-field>')" — on the login form that field is the
            # hidden <input name="return">.
            fieldsObj ?= {}
            valid = true
            firstFound = false
            $form.find('[name]').each ->
                $item = $(this)
                $parent = $(this).parent('div')
                $item.removeClass('invalid-value')
                $parent.find('> small').remove()
                name = $(this).attr('name')
                if fieldsObj[name] 
                    unless firstFound 
                        utility.focus $(this)
                        firstFound = true
                    valid = false
                    $item.addClass('invalid-value')
                    if fieldsObj[name] == "already on file" 
                        $parent.append($('<small class="form-error-message">').text "Already exists")
                    else
                        # console.log(fieldsObj[name])
                        $parent.append($('<small class="form-error-message">').text fieldsObj[name])

            return valid
            
        popBox: (source, options = {})->
            $insertSpace = $('[js-modal]')

            openPop = ($el)->
              if $('body').hasClass('modal-open')
                  closePop($el)
              else
                  $('body').addClass('modal-open')
                  $insertSpace.html ""
                  $spanTomato = $('<span class="red-tomato" style="padding-bottom:14px;"></span>')
                  $insertSpace.append $spanTomato
                  # Wrap content in a container for reliable click detection
                  $modalContent = $('<div class="modal-content-wrap"></div>')
                  $modalContent.append $el
                  $insertSpace.append $modalContent

                  # Only add close button if not disabled
                  unless options.showCloseButton is false
                      $closeButton = $('<button class="modal-close-button"><img src="/assets/images/ui/button-close.png"></button>')
                      $insertSpace.append $closeButton
                      $closeButton.on 'click', ->
                          closePop()

                  # Optionally disable background clicks
                  unless options.persistent is true
                      $insertSpace.on 'click', (e)->
                          if $(e.target).closest('.modal-content-wrap').length == 0 and not $(e.target).hasClass('modal-close-button')
                              closePop()

            closePop = ($el)->
                if $('#modal-frame').length > 0
                    $('#modal-frame').attr 'src', ''
                $('body').removeClass('modal-open')

                setTimeout ->
                    #$insertSpace.html ""
                    if $el
                        openPop $el
                , 500
            
            if source and source instanceof jQuery # it's a jquery object
                openPop source.clone true
            else if source and source.match /^#/g # it's an ID
                openPop $(source).children().clone true
            else if source and source.match /^\//g # it's a url to load
                $.get source, (response)->
                    openPop response
            else if source and source != "" # it's a string to show
                openPop $('<div>').html source
            else # we're just going to close the popup if one is open
                closePop()

        priceFormat : (amount, forceDecimal)->
            arParts = amount.toString().split('.')
            isNeg = Number(arParts[0]) < 0
            decPart = if arParts.length > 1 then arParts[1] else ''
            decPart = (decPart + '00').substr(0,2);
            intPart = arParts[0].replace /[^0-9.]/g, ""
            intPart = intPart.toString().replace /\B(?=(\d{3})+(?!\d))/g, ","
            if isNeg and 
                sign = '-$'
            else
                sign = '$'
            if decPart != '00' or forceDecimal
                return sign + intPart + '.' + decPart
            else
                return sign + intPart

        incrementValue : ($element, params, usesAnimation = true)->
            return unless $element and $element.length
            priceFormat = @priceFormat
            defaults =
            startValue : $element.eq(0).text().replace(/[^-0-9,.]/g, "") or '0'
            endValue : 0
            duration : usesAnimation ? 1000 : 0
            easing : 'linear'
            priceFormat : false
            labelSingular : ''
            labelPlural : ''
            forceDecimal : false
            ifZero : false
            # console.log(usesAnimation)
                
            params = $.extend defaults, params
            startDecimal = String(params.startValue) != String(Math.floor(params.startValue))
            endDecimal = String(params.endValue) != String(Math.floor(params.endValue))
            forceDecimal = startDecimal or endDecimal or params.forceDecimal
            onlyOne = Math.abs(Number(params.startValue) - Number(params.endValue)) <= .01

            # console.log 'incrementValue start value', params.startValue, Math.floor(params.startValue)

            formatOutput = (value)->
                preciseVal = String value
                roundVal = String Math.round value
                output = ''
                if value == 0 and params.ifZero != false
                    return params.ifZero
                if params.priceFormat
                    if forceDecimal
                        output += priceFormat preciseVal, true
                    else
                        output += priceFormat roundVal
                else
                    if forceDecimal
                        output += preciseVal
                    else
                        output += roundVal
                if params.labelSingular and roundVal == '1'
                    output += params.labelSingular
                else if params.labelPlural
                    output += params.labelPlural
                return output

            if onlyOne || !usesAnimation
                $element.html formatOutput params.endValue
            else
                $({someValue : params.startValue}).stop().animate
                    someValue : params.endValue
                ,
                    duration : params.duration
                    easing : params.easing
                    step : ->
                        $element.html formatOutput this.someValue
                    done : ->
                        $element.html formatOutput params.endValue

        moneyOnly : (input,callback)->
            regexPat = /^\$?([\d,]*)\.?(\d{0,2})$/
            input.on 'keydown paste', (e)->
                curVal = input.val()
                curStart = input[0].selectionStart
                curEnd = input[0].selectionEnd
                setTimeout ->
                    newVal = input.val()
                    unless regexPat.test newVal
                        input.val curVal
                        input[0].selectionStart = curStart
                        input[0].selectionEnd = curEnd
                , 0

            input.on 'keyup', (e)->
                if callback
                    callback()

            input.on 'blur', (e)->
                val = input.val()
                val = '0' unless val
                input.val @priceFormat val, true
			







slice = [].slice
(($, window) ->
  DragAndScroll = undefined
  DragAndScroll = do ->
    `var DragAndScroll`

    DragAndScroll = (el, options) ->
      @options = $.extend({}, @defaults, options)
      @$inner = $(el)
      @$outer = @$inner.parent()
      @innerWidth = null
      @innerHeight = null
      @outerWidth = null
      @outerHeight = null
      @resizeTimer = null
      @setDimensions()
      @bindResize()
      @touchDetected = false
      @detectTouch()
      @makeAutoScroll()
      return

    DragAndScroll::defaults =
      enableX: true
      enableY: true

    DragAndScroll::setDimensions = ->
      @innerWidth = @$inner.width()
      @innerHeight = @$inner.height()
      @outerWidth = @$outer.width()
      @outerHeight = @$outer.height()
      @maxWidth = @innerWidth - (@outerWidth)
      @maxHeight = @innerHeight - (@outerHeight)
      if @maxX < 0
        @$inner.css left: 0
      if @maxY < 0
        return @$inner.css(left: 0)
      return

    DragAndScroll::detectTouch = ->
      $(window).on 'touchstart', ((_this) ->
        (e) ->
          _this.touchDetected = true
          $(window).unbind e
      )(this)

    DragAndScroll::bindResize = ->
      $(window).on 'resize', ((_this) ->
        (e) ->
          if _this.resizeTimer
            clearTimeout _this.resizeTimer
          _this.resizeTimer = setTimeout((->
            _this.setDimensions()
          ), 50)
      )(this)

    DragAndScroll::makeAutoScroll = ->
      @$outer.on 'mousemove', ((_this) ->
        (e) ->
          heightPercent = undefined
          leftOffset = undefined
          offset = undefined
          topOffset = undefined
          widthPercent = undefined
          if !_this.touchDetected
            offset = _this.$outer.offset()
            widthPercent = (e.pageX - (offset.left)) / _this.outerWidth
            heightPercent = (e.pageY - (offset.top)) / _this.outerHeight
            leftOffset = _this.maxWidth * widthPercent
            topOffset = _this.maxHeight * heightPercent
            _this.$outer.scrollLeft leftOffset
            return _this.$outer.scrollTop(topOffset)
          return
      )(this)

    DragAndScroll
  $.fn.extend dragAndScroll: ->
    args = undefined
    option = undefined
    option = arguments[0]
    args = if 2 <= arguments.length then slice.call(arguments, 1) else []
    @each ->
      $this = undefined
      data = undefined
      $this = $(this)
      data = $this.data('dragAndScroll')
      if !data
        $this.data 'dragAndScroll', data = new DragAndScroll(this, option)
      if typeof option == 'string'
        return data[option].apply(data, args)
      return
) window.jQuery, window

$ ->

    'use strict'
    eventAjaxURL = "/event/ajax/"

    $('[js-fb-link]').attr 'href', 'http://www.facebook.com/sharer/sharer.php?u=' + location.href
    new WOW({
        boxClass: "scroll_effect"
        callback:
            -> $('div.loading-box').hide() if $('div.loading-box').length
        }).init()

    $('[js-nav-search]').on 'click', (e)->
        $slider = $('#search-slider')
        $input = $('#search-near-city [name="search"]')
        $body = $('body')
        setFocus = ->
            e.preventDefault()
            $input.prop 'disabled', false
            $input.trigger "focus"
            tmpStr = $input.val()
            $input.val('')
            $input.val(tmpStr)
        if $slider.length
            unless $body.hasClass('search-slider-open')
                $body.addClass('search-slider-open')
                setFocus()
            else
                $body.removeClass('search-slider-open')
                $input.prop 'disabled', true
            return false
        else if $input.length
            setFocus()

    $('[js-reserved-seating-button]').on 'click', (e)->
        if !$('[js-reserved-seating-button]').hasClass "hilight"
            $('[js-reserved-seating-button]').addClass "hilight"
        if $('[js-general-seating-button]').hasClass "hilight"
            $('[js-general-seating-button]').removeClass "hilight"
        if !$('#general_seating').hasClass "hidden"
            $('#general_seating').addClass "hidden", 200
        if $('#reserved_seating').hasClass "hidden"
            $('#reserved_seating').removeClass "hidden", 200

    $('[js-general-seating-button]').on 'click', (e)->
        if !$('[js-general-seating-button]').hasClass "hilight"
            $('[js-general-seating-button]').addClass "hilight"
        if $('[js-reserved-seating-button]').hasClass "hilight"
            $('[js-reserved-seating-button]').removeClass "hilight"
        if !$('#reserved_seating').hasClass "hidden"
            $('#reserved_seating').addClass "hidden", 200
        if $('#general_seating').hasClass "hidden"
            $('#general_seating').removeClass "hidden", 200

    $('[js-number-only]').each ->
        utility.numberInputOnly $(this)

    mobileNav = ->
        open = false
        $toggle = $('[js-mobile-menu-toggle]')
        $body = $('body')
        $toggle.on 'click', (e)->
            e.preventDefault()
            if open
                $body.removeClass('nav-open')
            else
                $body.addClass('nav-open')
            open = !open

    window.mobileNav = mobileNav()

    utility.makeEllipse $('[js-auto-ellipse]')

    loginForm = ->
        $loginForm = $('[js-login]')
        $loginSubmit = $loginForm.find('button[type="submit"]')
        $loginMessage = $loginForm.find('[js-login-message]')
        loginUrl = $loginForm.attr('js-login')

        $resetButton = $loginForm.find('[js-login-reset]')
        $resetForm = $('[js-reset]')
        $resetCancelButton = $resetForm.find('[js-reset-cancel]')
        resetUrl = $resetForm.attr('js-reset')
        loginProcessing = 0

        $resetButton.on 'click', (e)->
            e.preventDefault()
            utility.popBox "#modal-reset-form"

        $resetCancelButton.on 'click', (e)->
            e.preventDefault()
            utility.popBox null

        $loginForm.on 'submit', (e)->
            e.preventDefault()
            $loginSubmit.addClass('ajax').prop('disabled', true)
            $.ajax
                url: loginUrl
                method: 'post'
                data: $loginForm.serialize()
                dataType: 'json'
                success: (response)->
                    if response.success
                        $loginMessage.removeClass('blink')
                        #window.location.reload()
                        window.location.href = '/account'
                    else
                        $loginMessage.addClass('blink').html response.message
                        utility.caffelliServerValidateField $loginForm, response.data.user_errors
                        $loginSubmit.removeClass('ajax').prop('disabled', false)
                complete: ->
                    $loginSubmit.removeClass('ajax').prop('disabled', false)
                error: ->
                    utility.popBox "<h2>An error has occured.</h2>"

        $resetForm.on 'submit', (e)->
            e.preventDefault()
            $.ajax
                url: resetUrl
                method: 'post'
                data: $(this).serialize()
                dataType: 'json'
                success: (response)->
                    $(this).find('[js-reset-message]').addClass('blink').html response.message
                    if response.success
                        utility.popBox "<h2>An email has been sent. Please follow the instructions provided.</h2>"
                    else
                        utility.caffelliServerValidateField $resetForm, response.data.user_errors
                error: ->
                    utility.popBox "<h2>An error has occured.</h2>"


    if $('[js-login]')
        loginForm()


    registerForm = ->
        $form = $('[js-register]')
        $submit = $form.find('button[type="submit"]')
        $message = $form.find('[js-register-message]')
        url = $form.attr('js-register')

        $form.on 'submit', (e)->
            e.preventDefault()
            $submit.addClass('ajax').prop('disabled', false)
            $.ajax
                url: url
                method: 'post'
                data: $form.serialize()
                dataType: 'json'
                success: (response)->
                    $message.addClass('blink').html response.message
                    if response.success
                        window.location.href = response.data['user_data'].return
                    else
                        utility.caffelliServerValidateField $form, response.data.user_errors
                complete: ->
                    $submit.removeClass('ajax').prop('disabled', false)


    if $('[js-register]')
        registerForm()


    $('[js-logout]').on 'click', (e)->
        e.preventDefault()
        $.ajax
            url: "/logoff/logoff_ajax"
            dataType: 'json'
            success: (response)->
                if response.success
                    window.location.href = '/login'
                else
                    utility.popBox "An error occured while trying to log out"


    accountNav = ->
        $sections = $('#my-account, #my-orders')
        $links = $('[js-account-nav]').find('a')
        $links.on 'click', (e)->
            e.preventDefault()
            $sections.css display: 'none'
            $links.removeClass 'active'
            $(this).addClass 'active'
            id = $(this).attr('href')
            $sections.filter(id).css display: 'block'


    if $('[js-account-nav]')
        accountNav()


    accountForm = ->
        $form = $('[js-account]')
        $submit = $form.find('button[type="submit"]')
        $message = $form.find('[js-account-message]')
        url = $form.attr('js-account')

        $form.on 'submit', (e)->
            e.preventDefault()
            $.ajax
                url: url
                method: 'post'
                data: $form.serialize()
                dataType: 'json'
                success: (response)->
                    utility.caffelliServerValidateField $form, response.data.user_errors
                    if response.success
                        $message.html ""
                        utility.popBox "<h3>Your account has been updated.</h3>"
                    else
                        $message.html response.message


    accountForm = ->
        $form = $('[js-account]')
        $submit = $form.find('button[type="submit"]')
        $message = $form.find('[js-account-message]')
        url = $form.attr('js-account')

        $form.on 'submit', (e)->
            e.preventDefault()
            $.ajax
                url: url
                method: 'post'
                data: $form.serialize()
                dataType: 'json'
                success: (response)->
                    utility.caffelliServerValidateField $form, response.data.user_errors
                    if response.success
                        $message.html ""
                        utility.popBox "<h3>Your account has been updated.</h3>"
                    else
                        $message.html response.message

    if $('[js-account]')
        accountForm()


    seatingMap = ->
        $areas = $('[js-seating-map-area]')
        $select = $('[js-seating-map-select]')
        $button = $('[js-seating-map-button]')
        eventID = $select.attr('js-seating-map-select')

        $.each $areas, (i, area)->
            $area = $(area)
            pmpID = $area.attr('js-seating-map-area')

            touchMaxMS = 200
            touchStartMS = null

            $area.on 'mouseover', ->
                $select.val pmpID

            $area.on 'mouseout', ->
                $select.val ''

            $area.on 'click', (e)->
                #console.log 'seatingMap area click'
                e.preventDefault()
                $select.val pmpID
                loadSection pmpID

            $area.on 'touchstart', (e)->
                touchStartMS = (new Date()).getTime()
                #console.log 'seatingMap area touchstart'

            $area.on 'touchend', (e)->
                touchEndMS = (new Date()).getTime()
                if touchEndMS < touchStartMS + touchMaxMS
                    $area.trigger 'click'
                #console.log 'seatingMap area touchend'

        $button.on 'click', (e)->
            e.preventDefault()
            pmpID = $select.val()
            if pmpID
                loadSection pmpID
            else
                utility.popBox 'Please first select a section.'

        loadSection = (pmpID)->
            utility.popBox '/seating_chart/' + eventID + '/' + pmpID + '/?inhouse=0&seatBlock=0'
            setTimeout ->
                focusEl = document.getElementById('focus-here')
                if focusEl
                    focusEl.scrollIntoView
                        behavior: 'smooth'
                        block: 'start'
                        inline: 'start'
            ,1500

    if $('[js-seating-map-area]')
        seatingMap()

    if $('[js-drag-and-scroll]') && typeof $().dragAndScroll != "undefined"
        $('[js-drag-and-scroll]').dragAndScroll()

    navCountdown = ->
        if (Number $('#nav-countdown').attr('js-nav-countdown'))
            $('#nav-countdown').addClass('nav-timer')
            utility.countdownClock $('#nav-countdown'), Number $('#nav-countdown').attr('js-nav-countdown'), ->
                $('#nav-countdown').removeClass('nav-timer')
                $('#nav-countdown').attr('js-nav-countdown', "")
                $('#nav-countdown').html "&nbsp;"
                if window.location.pathname == "/checkout"
                    location.href = "/checkout"
        return

    navCountdown()


    EventPage = ->
        return

    EventPage::initBase = ->
        presaleFormSubmission()

    EventPage::init = ->
        # console.log "initializing event page"
        @initBase()
        return

    $.EventPage = new EventPage
    $.EventPage.Constructor = EventPage

    # reset ticket area
    updateTicketArea = (response) ->
        response = "<h3>Welcome to the Presale Event!</h3>" + response
        $('div.presale-area').delay(350).hide()
        $('div.presale-area').html response
        $('div.presale-area').delay(350).fadeIn('slow')
        seatingMap()
        return

    # setup form submission
    presaleFormSubmission = ->
        $form = $('form[name=presale_form]')
        $presaleFormSubmit = $('[js-presale-submit]')
        $form.on 'submit', (e)->
            console.log "form submission"
            e.preventDefault()
            $presaleFormSubmit.addClass('ajax').prop('disabled', true)
            $.getJSON eventAjaxURL + "?" + $form.serialize()
            .done (response) ->
                if !response.length
                    # console.log "done but failed"
                    $('[js-presale-message]').html "<span class='m-3 h5'>We are unable to verify your presale code.  Please review it and try again.</span>"
                    $('[js-presale-message]').removeClass("d-none")
                else
                    updateTicketArea(response)
                    $presaleFormSubmit.removeClass('ajax').prop('disabled', false)
            .fail (e) ->
                # console.log "complete failure"
                $('[js-presale-message]').html "<span class='m-3 h5'>We are unable to verify your presale code.  Please review it and try again.</span>"
                $('[js-presale-message]').removeClass("d-none")
                $presaleFormSubmit.removeClass('ajax').prop('disabled', false)


    if $('body.page-event').length
        # console.log "event page initialized"
        $.EventPage.init()

    showVideoInModal = ->
        $trigger = $('.trigger')

        $trigger.click (e) ->
            e.preventDefault()
            $videoSRC = $(this).attr('src')
            $videoSRCauto = $videoSRC + '?autoplay=1'

            $frame = '<div class="modal-video embed-responsive embed-responsive-16by9">\
                <iframe id="modal-frame" width="480" height="360" class="embed-responsive-item" src="'+$videoSRCauto+'" allowfullscreen></iframe>\
            </div>'

            utility.popBox $frame
            # console.log $(".modal-box")
            $(".modal-box").addClass 'modal-video'
            return
        return

    if $('.meet-video-container').length > 0
        showVideoInModal()

    return

$ ->

	musicPlayer = ->
		$players = $('[js-music]')

		playingTrack = null

		soundManager.setup
			url: "/assets/scripts/vendor/soundmanager/soundmanager2.swf"
			#autoLoad: true
			stream: true
			# preferFlash: true

		soundManager.onready ->
			$('[js-music]').each ->
				$player = $(this)
				$play = $(this).find('[js-music-play]')
				$prev = $(this).find('[js-music-prev]')
				$next = $(this).find('[js-music-next]')
				$tracker = $(this).find('[js-music-tracker]')
				$loader = $(this).find('[js-music-loader]')
				$position = $(this).find('[js-music-position]')

				playerTrack = 0

				playerTracks = []

				$(this).find('[js-music-track]').each (i)->
					$el = $(this)
					$duration = $el.find('[js-music-duration]')
					track =
						$el: $el
						sm: soundManager.createSound
							url: $(this).attr('js-music-track')
							whileplaying: ->
								$position.css
									width: Math.round(this.position / this.duration * 100) + "%"
							whileloading: ->
								$loader.css
									width: Math.round(this.bytesLoaded / this.bytesTotal * 100) + "%"

							onload: ->
								# $loader.css
								# 	width: "100%"
							onplay: ->
								if playingTrack
									playingTrack.sm.stop()
								$position.css
									width: "0%";
								$el.addClass('active')
								$play.addClass('pause')
								playerTrack = i
								playingTrack = track
							onpause: ->
								$play.removeClass('pause')
							onresume: ->
								$play.addClass('pause')
							onstop: ->
								$el.removeClass('active')
								$play.removeClass('pause')
								playingTrack = null
								$position.css
									width: "0%";
							onfinish: ->
								$el.removeClass('active')
								if i < playerTracks.length-1
									playerTracks[i+1].sm.play()
								else
									playerTrack = 0
								

					playerTracks.push track

					track.$el.on 'click', ->
						track.sm.play()

				$play.on 'click', ->
					if playingTrack == playerTracks[playerTrack]
						playerTracks[playerTrack].sm.togglePause()
					else if playingTrack
						playingTrack.sm.stop()
						playerTracks[playerTrack].sm.play()
					else
						playerTracks[playerTrack].sm.play()

				$next.on 'click', ->
					if playerTrack < playerTracks.length-1
						playerTrack += 1
					else
						playerTrack = 0
					playerTracks[playerTrack].sm.play()

				$prev.on 'click', ->
					if playerTrack > 0
						playerTrack -= 1
					else
						playerTrack = playerTracks.length-1
					playerTracks[playerTrack].sm.play()

				$tracker.on 'click', (e)->
					if playingTrack == playerTracks[playerTrack]
						offset = e.pageX - $(this).offset().left
						width = $(this).width()
						position = Math.round playingTrack.sm.duration * (offset / width)
						#console.log position, playingTrack.sm.durationEstimate, playingTrack.sm.duration
						playingTrack.sm.setPosition position

					

						

					

						
	

	if $('[js-music]').length
		musicPlayer()
$ ->
    calendarPage = ->
        $eventList = $('[js-event-list]')
        $eventMonths = $eventList.find('.monthly-event-container')

        $searchForm = $('[js-search]')
        $searchCity = $searchForm.find('[name="city"]')
        $searchText = $searchForm.find('[name="search"]')

        $eventNone = $('[js-event-none]')
        
        utility.focus $searchText

        eventData = []
        $eventMonths.each (i)->
            events = []
            $(this).next('div').find('[js-event]').each (i)->
                data = $(this).attr('js-event').split('||')
                events.push
                    city: data[0].replace(/^\s+|\s+$/g, '').toLowerCase()
                    search: data[1].replace(/^\s+|\s+$/g, '').toLowerCase()
                    $el:	$(this)
                    display: null
            eventData.push
                $el: $(this)
                $container: $(this).next('div')
                display: null
                events: events

        filterEvents = ->
            if $('body.page-calendar').length > 0
                city = $searchCity.val().replace(/^\s+|\s+$/g, '').toLowerCase()
                # Split on any run of non-alphanumeric chars (commas, punctuation, extra spaces)
                # and drop empties, so "Ocean Park, WA" tokenizes as Ocean/Park/WA.
                # ASCII class (not \p{L}) on purpose: a \p{L}/u parse error would break the whole bundle on legacy browsers.
                searchArray = $searchText.val().split(/[^a-z0-9]+/i).filter (w) -> w.length > 0

                queryString = utility.setQueryVars
                    search: $searchText.val()
                    city: $searchCity.val()

                if history.replaceState
                    history.replaceState {}, 'Calendar | Ticket Tomato', '/calendar' + queryString

                checkEvent = (event)->
                    inCity = city == "all" or event.city == city
                    # console.log event.city, city
                    searchMatch = true
                    for word in searchArray
                        word = word.toLowerCase()
                        unless event.search.indexOf(word) >= 0
                            searchMatch = false
                    # console.log inCity
                    return inCity and searchMatch

                anyMatches = false
                for month in eventData
                    month.display = false
                    for event in month.events
                        event.display = false
                        if checkEvent(event)
                            month.display = true
                            event.display = true
                            anyMatches = true

                $eventList.animate
                    opacity: 0
                , 300
                , ->
                    for month in eventData
                        if month.display
                            month.$el.show()
                            month.$el.css "visibility", "visible"
                        else
                            month.$el.hide()
                        for event in month.events
                            if event.display
                                event.$el.show()
                                event.$el.css "visibility", "visible"
                            else
                                event.$el.hide()
                                event.$el.css "visibility", "hidden"
                    if anyMatches
                        $eventNone.hide()
                        $eventNone.css "visibility", "hidden"
                    else
                        $eventNone.show()
                        $eventNone.css "visibility", "visible"
                    $eventList.animate
                        opacity: 1
                    , 400
        

        $searchCity.on 'change', ->
            # Choosing a real city clears the free-text search, so a city and a
            # stale search term don't intersect to nothing. Search and city are
            # mutually exclusive: activating one clears the other. (Picking "All
            # Cities" just clears the city and leaves any search in place.)
            # This handler fires for both the tag-cloud (citycloud.coffee triggers
            # 'change') and the classic dropdown (custom-select.coffee does too).
            if $searchCity.val() != 'all'
                $searchText.val ''
            filterEvents()

        $searchForm.on 'submit', (e)->
            e.preventDefault()
            filterEvents()

        searchDebounce = null
        $searchText.on 'keyup', ->
            # Typing a search blanks the city filter back to "all cities" so the
            # results aren't silently narrowed by a previously chosen city. Also
            # resets the classic dropdown's visible label (no-op in tag-cloud mode).
            if $searchText.val().replace(/^\s+|\s+$/g, '') != '' and $searchCity.val() != 'all'
                $searchCity.val 'all'
                $searchCity.closest('.tomato-custom-select').find('.select-selected').text 'Include All Cities'
            if searchDebounce
                clearTimeout searchDebounce
            searchDebounce = setTimeout ->
                filterEvents()
            , 250

        $(document).ready filterEvents()

        self = 
             debug: {'eventData' : eventData}
        #     debug: -> console.log {'eventData' : eventData}

        return self

    if $('body.page-calendar').length > 0
        window.calendarPage = calendarPage()

# City filter tag-cloud panel.
# Progressive enhancement over the hidden <select name="city"> that the calendar
# filter (calendar.coffee) already listens to. The trigger button slides a white
# panel down from under the header; clicking a city sets the select value and either
# filters live (calendar page) or submits the search form (everywhere else).
$ ->
    $filters = $('[js-city-filter]')
    if $filters.length == 0
        return

    isCalendar = $('body').hasClass('page-calendar')

    $filters.each ->
        $filter  = $(this)
        $trigger = $filter.find('[js-city-trigger]')
        $panel   = $filter.find('[js-city-panel]')
        $select  = $filter.find('select[name="city"]')
        $label   = $filter.find('.city-filter-trigger-label')
        $tags    = $filter.find('.city-tag')

        closePanel = ->
            $('body').removeClass 'city-filter-open'
            $trigger.attr 'aria-expanded', 'false'

        openPanel = ->
            $('body').addClass 'city-filter-open'
            $trigger.attr 'aria-expanded', 'true'

        $trigger.on 'click', (e) ->
            e.stopPropagation()
            if $('body').hasClass('city-filter-open')
                closePanel()
            else
                openPanel()

        $tags.on 'click', ->
            city = $(this).attr 'data-city'
            $select.val city

            $tags.removeClass 'is-selected'
            $(this).addClass 'is-selected'

            if city == 'all'
                $label.text 'Search By City'
            else
                $label.text $(this).attr('data-city')
                # Mutually exclusive with free-text search: picking a real city clears
                # the search box. Needed for the home-page form-submit path below; on
                # the calendar page calendar.coffee's 'change' handler also clears it.
                $trigger.closest('form').find('[name="search"]').val ''

            closePanel()

            if isCalendar
                # Reuse the existing live filter in calendar.coffee.
                $select.trigger 'change'
            else
                # Off the calendar page, hand off to the search form -> /calendar?city=...
                $trigger.closest('form').submit()

        # Typing in the free-text search blanks the city filter back to "All Cities"
        # (keeps the tag-cloud UI in sync with the reset calendar.coffee performs).
        resetToAll = ->
            $select.val 'all'
            $tags.removeClass 'is-selected'
            $filter.find('.city-tag-all').addClass 'is-selected'
            $label.text 'Search By City'

        # Guard on the visible selection, not $select.val(): calendar.coffee (loaded
        # first) may have already reset the select to 'all' on this same keyup.
        $trigger.closest('form').find('[name="search"]').on 'keyup input', ->
            if $(this).val().replace(/^\s+|\s+$/g, '') != '' and not $filter.find('.city-tag-all').hasClass('is-selected')
                resetToAll()

        # Keep the panel from closing when clicking inside it.
        $panel.on 'click', (e) ->
            e.stopPropagation()

    # Dismiss on outside click or Esc.
    $(document).on 'click', ->
        $('body').removeClass 'city-filter-open'
        $('[js-city-trigger]').attr 'aria-expanded', 'false'

    $(document).on 'keyup', (e) ->
        if e.key == 'Escape' or e.keyCode == 27
            $('body').removeClass 'city-filter-open'
            $('[js-city-trigger]').attr 'aria-expanded', 'false'

$ ->
    
    teamPage = ->
        $carousel = $('[js-team-carousel]')
        $selectors = $('[js-team-select]')

        $selectors.on 'click', (e)->
            e.preventDefault()
            current = $carousel.attr('js-team-carousel')
            selected = $(this).attr('js-team-select')
            $('[js-team-select="' + current + '"]').removeClass('active')
            $('[js-team-select="' + selected + '"]').addClass('active')
            $carousel.attr('js-team-carousel', selected)
            $carousel.addClass('IE').removeClass('IE') #hack to trigger IE DOM update
            $('html, body').animate { scrollTop: $('#team-carousel').offset().top - 75}, 500, 'linear'

    if $('[js-team-carousel]').length
        teamPage()

$ ->
  cartPage = ->

    getURL = "/cart/view_ajax"
    updateURL = "/cart/update_cart_ajax"
    removeURL = "/cart/remove_ajax/"
    submitURL = "/order/process_ajax"
    cartUpdate = false
    cartData = []

    $form = $('[js-cart]')

    $updateCart = $form.find('[js-cart-update]')
    $checkoutCart = $form.find('[js-cart-checkout]')

    $allInputs = $form.find('[name]')
    $radioInputs = $form.find('input[type=radio]')

    $disclaimerButton = $form.find('[js-cart-disclaimer-button]')

    $couponInput = $form.find('[js-cart-coupon-input]')

    $someValid = $form.find('[js-cart-some-valid]')
    $allExpired = $form.find('[js-cart-all-expired]')
    $cartEmpty = $form.find('[js-cart-empty]')

    $checkboxes = $form.find('input[type=checkbox]')

    $subtotal = $('[js-cart-subtotal]')
    $fees = $('[js-cart-fees]')
    $ccFee = $('[js-cart-cc-fee]')
    $taxes = $('[js-cart-taxes]')
    $donations = $('[js-cart-donations]')
    $coupons = $('[js-cart-coupons]')
    $discounts = $('[js-cart-discounts]')
    $discountButton = $('button.discount-code')
    $total = $('[js-cart-total]')

    $checkboxes.on 'click', (e)->
       $checkboxes.each ->
           $(this).prop("checked", true)
       return true

    $cartRows = $form.find('[js-cart-row]')

    $cartRows.each ->
      vals = $(this).attr('js-cart-row').split('|')
      row =
        $el: $(this)
        id: vals[0].replace /\s+/g, ""
        expiresMS: Number vals[3]
        stillValid: (Number vals[3]) > 0
        $remove: $(this).find('[js-cart-remove]')
        $expires: $(this).find('[js-cart-expires]')
        $disclaimer: $(this).find('[js-cart-disclaimer-box]')
        $donationsRadios: $(this).find('[js-row-donations] input[type="radio"]')
        $donationsInput: $(this).find('[js-row-donations] input[type="text"]')
        $registrationFields: $(this).find('[js-registration-fields]')
        $questionnaireFields: $(this).find('[js-questionnaire-fields]')
        $total: $(this).find('[js-row-total]')
        $price: $(this).find('[js-row-price]')
        $fee: $(this).find('[js-row-fee]')
        $donation: $(this).find('[js-row-donation]')
        $coupon: $(this).find('[js-row-coupon]')
        $couponCode: $(this).find('[js-row-coupon-code]')
        $discount: $(this).find('[js-row-discount]')
        $section: $(this).find('[js-row-section]')

      utility.moneyOnly row.$donationsInput

      row.$remove.on 'click', (e)->
        e.preventDefault()
        e.stopPropagation()
        csrfData = utility.getCsrfToken()
        csrfData.seat_id = row.id
        $.ajax
          url: removeURL + row.id
          method: 'post'
          data: csrfData
          dataType: 'json'
          success: (response)->
            updateSummary(response)
            row.$el.addClass('removed')

      row.$donationsRadios.on 'click', ->
        if $(this).val() == 'other'
          row.$donationsInput.focus()
        else
          row.$donationsInput.val('')
          updateCart()

      row.$donationsInput.on 'keyup', ->
        row.$donationsRadios.filter("[value='other']").click()

      if row.expiresMS
        utility.countdownClock row.$expires, row.expiresMS, ->
          row.$expires.text "EXPIRED"
          row.$el.addClass('expired')
          row.stillValid = false
          $.getJSON getURL, (response)->
            updateSummary(response)
            location.reload()

      cartData.push row

    $allInputs.on 'keydown', (e)->
      if e.keyCode == 13
        e.preventDefault()
        e.stopPropagation()
        if e.target.name != "discount_code"
            updateCart()
        return false

    $allInputs.on 'blur', (e)->
      updateCart()

    $allInputs.on 'click', (e)->
      if e.target.name != "discount_code"
         updateDiscount(e.target)

    $discountButton.on 'click', (e)->
        updateDiscount(e.target)

    $disclaimerButton.on 'click', (e)->
      e.preventDefault()
      if !$updateCart.hasClass('ajax')
          $updateCart.addClass('ajax').prop('disabled', true)
          $.ajax
            url: e.target.href
            method: 'get'
            dataType: 'html'
            success: (response)->
              utility.popBox response
              $updateCart.removeClass('ajax').prop('disabled', false)
            error: (response)->
              window.open(e.target.href)
              $updateCart.removeClass('ajax').prop('disabled', false)
            complete: ->
              $updateCart.removeClass('ajax').prop('disabled', false)

    $form.on 'submit', (e)->
      e.preventDefault()
      e.stopPropagation()
      return false

    $updateCart.on 'click', (e)->
      e.preventDefault()
      updateCart()
      return false

    $checkoutCart.on 'click', (e)->
      if !(checkDisclaimers())
        e.preventDefault()
        utility.popBox "<h2>One or more tickets in your cart has special terms.  Please read and accept the terms before proceeding to checkout.</h2>"
      else if checkRegistrationFields() and checkQuestionnaireFields()
        updateCart()
        # the page now follows the hyperlink to checkout
      else
        e.preventDefault()
        utility.popBox "<h2>Please be sure to fill in all required ticket fields marked with (<span class='text-danger'</span>&nbsp;*&nbsp;</span>) before continuing.</h2>"

    checkRegistrationFields = ->
      allValid = true
      for row in cartData
        if row.stillValid and row.$registrationFields.length
          firstName = row.$registrationFields.find("[name^='seat_first_name']").val()
          lastName = row.$registrationFields.find("[name^='seat_last_name']").val()
          email = row.$registrationFields.find("[name^='seat_email']").val()
          emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i
          firstNameValid = firstName.length > 0
          lastNameValid = lastName.length > 0
          emailValid = email.match(emailRegex)
          unless firstNameValid and lastNameValid and emailValid
            allValid = false

      return allValid

    checkQuestionnaireFields = ->
      allValid = true
      for row in cartData
        if row.stillValid and row.$questionnaireFields.length
          # Validate text inputs
          textFields = row.$questionnaireFields.find('input[type="text"]')
          for field in textFields
            isRequired = $(field).attr('data-required') == 'true'
            if isRequired and !field.value.trim()
              allValid = false

          # Validate radio button groups
          radioGroups = row.$questionnaireFields.find('.questionnaire-radio-group')
          for group in radioGroups
            isRequired = $(group).attr('data-required') == 'true'
            if isRequired
              hasChecked = $(group).find('input[type="radio"]:checked').length > 0
              unless hasChecked
                allValid = false

      return allValid

    checkDisclaimers = ->
      allValid = true
      for row in cartData
        if row.stillValid and row.$disclaimer.length
          disclaimer_box = row.$disclaimer[0].checked
          unless disclaimer_box
            allValid = false

      return allValid

    updateCart = ->
      if ! cartUpdate
          cartUpdate = true
          $updateCart.addClass('ajax').prop('disabled', true)
          $.ajax
            url: updateURL
            data: $form.serialize()
            method: 'post'
            dataType: 'json'
            success: (response)->
              updateSummary(response)
              $updateCart.removeClass('ajax').prop('disabled', false)
              cartUpdate = false
            error: (response)->
              if response.message
                utility.popBox '<div style="text-align:left" class="h4">' + response.message + '</div>'
              $updateCart.removeClass('ajax').prop('disabled', false)
              cartUpdate = false
            complete: ->
              $updateCart.removeClass('ajax').prop('disabled', false)
              cartUpdate = false

    updateDiscount = (discOption)->
      if ! $updateCart.hasClass('ajax')
          $updateCart.addClass('ajax').prop('disabled', true)
          if discOption.textContent != "Apply"
            formdat = $form.find("input[name!=discount_code]").serialize()
          else
            formdat = $form.serialize()
          $.ajax
            url: updateURL
            data: formdat
            method: 'post'
            dataType: 'json'
            success: (response)->
              if response.message
                if response.message.trim().charAt(1) == "<"
                  discForm = $.parseJSON(response.message)
                  if discOption
                    $("input[name='"+discOption.name+"']:first").prop('checked', true).trigger('change')
                    discForm = discForm.replace(/specID/g, discOption.id)
                  utility.popBox discForm
                else
                  if discOption
                    $("input[name='"+discOption.name+"']:first").prop('checked', true).trigger('change')
                  utility.popBox '<div class="h4">' + response.message + '</div>'
              else
                utility.popBox ""
              updateSummary(response)
              # Clear the coupon input after a successful apply so the customer
              # can immediately enter the next code (multi-coupon carts apply
              # one coupon per category, see Cart_model::applyCoupons).
              if response.coupon_applied
                $couponInput.val ''
              $updateCart.removeClass('ajax').prop('disabled', false)
            error: (response)->
              if response.message
                utility.popBox '<div style="text-align:left">' + response.message + '</div>'
              $updateCart.removeClass('ajax').prop('disabled', false)
            complete: ->
              $updateCart.removeClass('ajax').prop('disabled', false)

    updateSummary = (response)->
      anyValid = false
      anyInCart = false
      for row in cartData
        data = response.tickets[row.id]
        if data
          anyInCart = true
          if data.seat_expires > 0
            anyValid = true
          row.$section.find('span').html data.category_name
          utility.incrementValue row.$total.find('span'), {
            priceFormat: true
            forceDecimal: true
            endValue: data.seat_price
          }, false
          utility.incrementValue row.$price.find('span'),{
            priceFormat: true
            forceDecimal: true
            endValue: data.seat_ticket_price
          }, false
          utility.incrementValue row.$fee.find('span'),{
            priceFormat: true
            forceDecimal: true
            endValue: data.seat_fee_price
          }, false

          if Number(data.seat_donation_price) != 0
            row.$donation.css
              display: 'flex'
            utility.incrementValue row.$donation.find('span'),{
              priceFormat: true
              forceDecimal: true
              endValue: data.seat_donation_price
            }, false
          else
            row.$donation.css
              display: 'none'
            row.$donation.find('span').text "$0.00"

          if data.seat_coupon_price and data.seat_coupon_price != "0.00"
            row.$coupon.css
              display: 'flex'
            utility.incrementValue row.$coupon.find('[js-row-coupon-amount]'),{
              priceFormat: true
              forceDecimal: true
              endValue: data.seat_coupon_price
            }, false
            if data.seat_coupon
              # Leading non-breaking space keeps "Coupon" and the code from
              # touching when the parent is a flex container (which collapses
              # the trailing whitespace of the static "Coupon" text node).
              row.$couponCode.text ' ' + data.seat_coupon
              row.$couponCode.css display: 'inline'
            else
              row.$couponCode.text ''
              row.$couponCode.css display: 'none'
          else
            row.$coupon.css
              display: 'none'
            row.$coupon.find('[js-row-coupon-amount]').text "$0.00"
            row.$couponCode.text ''

          if data.seat_discount_price and data.seat_discount_price != "0.00"
            row.$discount.css
              display: 'flex'
            utility.incrementValue row.$discount.find('span'),{
              priceFormat: true
              forceDecimal: true
              endValue: data.seat_discount_price
            }, false
          else
            row.$discount.css
              display: 'none'
            row.$discount.find('span').text "$0.00"
        else
          row.$el.addClass('removed')

      if anyValid
        utility.incrementValue $subtotal,
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.subtotal
        utility.incrementValue $subtotal,{
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.subtotal
        }, false
        utility.incrementValue $total,{
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.total
        }, false
        utility.incrementValue $fees,{
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.fees
        }, false
        utility.incrementValue $ccFee,{
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.cc_fee
        }, false

        if Number(response.totals.taxes) > 0
          $taxes.parent().css
            display: 'flex'
          utility.incrementValue $taxes,{
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.taxes
          }, false
        else
          $taxes.text "$0.00"
          $taxes.parent().css
            display: 'none'

        if Number(response.totals.donations) > 0
          $donations.parent().css
            display: 'flex'
          utility.incrementValue $donations,{
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.donations
          }, false
        else
          $donations.text "$0.00"
          $donations.parent().css
            display: 'none'

        if Number(response.totals.discounts) != 0
          $discounts.parent().css
            display: 'flex'
          utility.incrementValue $discounts,{
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.discounts
          }, false
        else
          $discounts.text "$0.00"
          $discounts.parent().css
            display: 'none'

        if Number(response.totals.coupons) != 0
          $coupons.parent().css
            display: 'flex'
          utility.incrementValue $coupons,{
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.coupons}
          , false
        else
          $coupons.text "$0.00"
          $coupons.parent().css
            display: 'none'

      if !anyInCart
        $someValid.css
          display: 'none'
        $cartEmpty.css
          display: 'block'
        $allExpired.css
          display: 'none'
      else if !anyValid
        $someValid.css
          display: 'none'
        $allExpired.css
          display: 'block'






  if $('[js-cart]')
    cartPage()

$ ->

  checkoutPage = ->
    $form = $('[js-checkout]')
    $submitButton = $('[js-cart-submit]')
    getURL = "/cart/view_ajax"
    updateURL = "/cart/update_cart_ajax"
    saveURL = $form.attr('js-checkout')

    # Polling configuration
    orderStatusURL = "/order/check_order_status"
    maxPollAttempts = 300  # Poll for up to 5 minutes (300 seconds)
    pollInterval = 1000    # Poll every 1 second

    elements = null
    paymentElement = null
    currentClientSecret = null
    currentOrderId = null
    $processingOrder = false
    consecutiveNetworkErrors = 0
    networkWarningShown = false 

    $someValid = $form.find('[js-cart-some-valid]')
    $allExpired = $form.find('[js-cart-all-expired]')
    $cartEmpty = $form.find('[js-cart-empty]')

    $subtotal = $('[js-cart-subtotal]')
    $fees = $('[js-cart-fees]')
    $taxes = $('[js-cart-taxes]')
    $donations = $('[js-cart-donations]')
    $coupons = $('[js-cart-coupons]')
    $discounts = $('[js-cart-discounts]')
    $total = $('[js-cart-total]')

    $updateCart = $form.find('[js-cart-update]')
    $allInputs = $form.find('[name]')
    cartUpdate = false

    $cartExpires = $form.find('[js-cart-expires]')

    review =
      $name: $form.find('[js-confirm-name]')
      $card: $form.find('[js-confirm-card]')
      $email: $form.find('[js-confirm-email]')
      $address: $form.find('[js-confirm-address]')
      $accept: $form.find('[js-confirm-accept]')
      $consent: $form.find('[js-confirm-consent]')

    general =
      $el: $form.find('[js-checkout-general]')
      $edit: $form.find('[js-checkout-general] [js-checkout-edit]')
      $save: $form.find('[js-checkout-general] [js-checkout-save]')
      ready: false
    confirm =
      $el: $form.find('[js-checkout-confirm]')
      $edit: $form.find('[js-checkout-confirm] [js-checkout-edit]')
      $save: $form.find('[js-checkout-confirm] [js-checkout-save]')
      ready: false
    billing =
      $el: $form.find('[js-checkout-billing]')
      $edit: $form.find('[js-checkout-billing] [js-checkout-edit]')
      $save: $form.find('[js-checkout-billing] [js-checkout-save]')
      ready: !$form.find('[js-checkout-billing]').length          #set billing to ready, if there is no billing object ($0 order)

    $accordionTooglerButton = $('.tf-toggler-button')

    general.$save.on "click", ->
      general.$save.addClass('ajax').prop('disabled', true)
      doSection general, (fields)->
        general.$save.removeClass('ajax').prop('disabled', false)

        if general.$el.hasClass "show-details"
          $($accordionTooglerButton[0]).trigger "click"
        $("html, body").animate
          scrollTop: confirm.$el.offset().top - 100
        , 300
        setTimeout(() ->
          confirm.$el.removeClass "locked-form"
          if !confirm.$el.hasClass "show-details"
            $($accordionTooglerButton[1]).trigger "click"
        , 300)
        #.find('[name]').first().focus()
        review.$name.html fields.first_name.value + ' ' + fields.last_name.value
        review.$email.html fields.email.value
        review.$accept.html fields.condition.checked
        review.$consent.html fields.consent.checked

    general.$edit.on "click", ->
      general.$el.removeClass('edit').addClass('show save').find('[name]').first().focus()

    confirm.$save.on "click", ->
      confirm.$save.addClass('ajax').prop('disabled', true)
      doSection confirm, (fields)->
        confirm.$save.removeClass('ajax').prop('disabled', false)
        ###
        confirm.$el.removeClass('save show').addClass('edit')
        billing.$el.removeClass('edit').addClass('show save').find('[name]').first().focus()
        ###
        if confirm.$el.hasClass "show-details"
          $($accordionTooglerButton[1]).trigger "click"
        $("html, body").animate
          scrollTop: billing.$el.offset().top - 100
        , 300
        setTimeout(() ->
          billing.$el.removeClass "locked-form"
          if !billing.$el.hasClass "show-details"
            $($accordionTooglerButton[2]).trigger "click"
        , 300)
    confirm.$edit.on "click", ->
      confirm.$el.removeClass('edit').addClass('show save').find('[name]').first().focus()


    $allInputs.on 'blur', (e)->
      updateCart()

    $cartRows = $form.find('[js-cart-row]')
    cartData = []

    $cartRows.each ->
      vals = $(this).attr('js-cart-row').split('|')
      row =
        $el: $(this)
        id: vals[0].replace /\s+/g, ""
        expiresMS: Number vals[3]
        $expires: $(this).find('[js-cart-expires]')
        $total: $(this).find('[js-row-total]')
        $price: $(this).find('[js-row-price]')
        $fee: $(this).find('[js-row-fee]')
        $donation: $(this).find('[js-row-donation]')
        $coupon: $(this).find('[js-row-coupon]')
        $discount: $(this).find('[js-row-discount]')
        $section: $(this).find('[js-row-section]')

      if row.expiresMS
        utility.countdownClock row.$expires, row.expiresMS, ->
          row.$expires.text "EXPIRED"
          row.$el.addClass('expired')
          row.stillValid = false
          $.getJSON getURL, (response)->
            updateSummary(response)
            location.reload()

      cartData.push row

    updateCart = ->
      # console.log("updating cart")
      return if $processingOrder  # Skip cart updates during payment processing
      if ! cartUpdate
          cartUpdate = true
          $updateCart.addClass('ajax').prop('disabled', true)
          $.ajax
            url: updateURL
            data: $form.serialize()
            method: 'post'
            dataType: 'json'
            success: (response)->
              updateSummary(response)
              $updateCart.removeClass('ajax').prop('disabled', false)
              cartUpdate = false
            error: (response)->
              if response.message
                utility.popBox '<div style="text-align:left" class="h4">' + response.message + '</div>'
              $updateCart.removeClass('ajax').prop('disabled', false)
              cartUpdate = false
            complete: ->
              $updateCart.removeClass('ajax').prop('disabled', false)
              cartUpdate = false

    updateSummary = (response)->
      anyValid = false
      anyInCart = false
      for row in cartData
        data = response.tickets[row.id]
        if data
          anyInCart = true
          if data.seat_expires > 0
            anyValid = true
          row.$section.find('span').text data.category_name
          utility.incrementValue row.$total.find('span'), {
            priceFormat: true
            forceDecimal: true
            endValue: data.seat_price
          }, false
          utility.incrementValue row.$price.find('span'),
            priceFormat: true
            forceDecimal: true
            endValue: data.seat_ticket_price
          utility.incrementValue row.$fee.find('span'),
            priceFormat: true
            forceDecimal: true
            endValue: data.seat_fee_price

          if Number(data.seat_donation_price) isnt 0
            row.$donation.css
              display: 'flex'
            utility.incrementValue row.$donation.find('span'),
              priceFormat: true
              forceDecimal: true
              endValue: data.seat_donation_price
          else
            row.$donation.css
              display: 'none'
            row.$donation.find('span').text "$0.00"

          if data.seat_coupon_price and data.seat_coupon_price != "0.00"
            row.$coupon.css
              display: 'flex'
            utility.incrementValue row.$coupon.find('span'),
              priceFormat: true
              forceDecimal: true
              endValue: data.seat_coupon_price
          else
            row.$coupon.css
              display: 'none'
            row.$coupon.find('span').text "$0.00"

          if data.seat_discount_price and data.seat_discount_price != "0.00"
            row.$discount.css
              display: 'flex'
            utility.incrementValue row.$discount.find('span'),
              priceFormat: true
              forceDecimal: true
              endValue: data.seat_discount_price
          else
            row.$discount.css
              display: 'none'
            row.$discount.find('span').text "$0.00"
        else
          row.$el.addClass('removed')

      if anyValid
        utility.incrementValue $subtotal,
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.subtotal
        utility.incrementValue $total,
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.total
        utility.incrementValue $fees,
          priceFormat: true
          forceDecimal: true
          endValue: response.totals.fees

        if Number(response.totals.taxes) > 0
          $taxes.parent().css
            display: 'flex'
          utility.incrementValue $taxes,
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.taxes
        else
          $taxes.text "$0.00"
          $taxes.parent().css
            display: 'none'

        if Number(response.totals.donations) > 0
          $donations.parent().css
            display: 'flex'
          utility.incrementValue $donations,
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.donations
        else
          $donations.text "$0.00"
          $donations.parent().css
            display: 'none'

        if Number(response.totals.discounts) isnt 0
          $discounts.parent().css
            display: 'flex'
          utility.incrementValue $discounts,
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.discounts
        else
          $discounts.text "$0.00"
          $discounts.parent().css
            display: 'none'

        if Number(response.totals.coupons) isnt 0
          $coupons.parent().css
            display: 'flex'
          utility.incrementValue $coupons,
            priceFormat: true
            forceDecimal: true
            endValue: response.totals.coupons
        else
          $coupons.text "$0.00"
          $coupons.parent().css
            display: 'none'

      if !anyInCart
        $someValid.css
          display: 'none'
        $cartEmpty.css
          display: 'block'
        $allExpired.css
          display: 'none'
      else if !anyValid
        $someValid.css
          display: 'none'
        $allExpired.css
          display: 'block'

    doSection = (section, callback)->
      $.ajax
        url: saveURL
        method: "post"
        data: getFormData(section)
        dataType: 'json'
        success: (response, status, xhr)->
          objs = {}
          for key, value of response.fields
            if value.message
              objs[key] = value.message
          if utility.caffelliServerValidateField section.$el, objs
            section.ready = true
            callback(response.fields)

            # CRITICAL: Sync order_id from backend response
            # When backend creates a new order (e.g., old order had succeeded PaymentIntent),
            # we must update the hidden form field so polling uses the correct order_id
            if response.fields?.order_id?.value
              $('input[name="order_id"]').val(response.fields.order_id.value)

            # Also sync payment_intent_id if backend created a new one
            if response.fields?.payment_intent_id?.value
              $('input[name="payment_intent_id"]').val(response.fields.payment_intent_id.value)
          else
            utility.setAccordionFormStyles()
            section.ready = false
            confirm.$el.removeClass('show')
            section.$save.removeClass('ajax').prop('disabled', false)

          # Check which Stripe mode to use
          isLegacy = response.fields.use_legacy?.value || window.STRIPE_USE_LEGACY
          hasClientSecret = response.fields.stripe_secret?.value

          if general.ready and confirm.ready
            billing.$el.addClass('show')

            if !isLegacy and hasClientSecret
              # Modern mode - use PaymentElement for PaymentIntent flow
              if !paymentElement
                elements = stripe.elements({ clientSecret: response.fields.stripe_secret.value })
                paymentElement = elements.create('payment', {
                  layout: 'accordion'
                  wallets: {
                    applePay: 'auto'
                    googlePay: 'auto'
                  }
                })
                paymentElement.mount('#payment-element')
            else if isLegacy
              # Legacy mode - traditional card input fields (for card readers)
              return
          else
            billing.$el.removeClass('show')
        error: (response)->
          utility.popBox '<div style="text-align:left">' + response.responseText + '</div>'

    getFormData = (section) ->
        data = section.$el.find('[name]')
        serialized = data.serialize()
        # Add CSRF token from form level (outside sections)
        csrfToken = utility.getCsrfToken()
        for key, value of csrfToken
          serialized += "&" + key + "=" + encodeURIComponent(value)
        $.each data, (key, value) ->
           if $(value).attr("type") == "checkbox" and !$(value).is(":checked")
               serialized += "&" + $(value).attr("name") + "=0"
           return
        return serialized

    # Order status polling
    pollOrderStatus = (orderId, attemptCount = 0) ->
      if attemptCount >= maxPollAttempts
        $processingOrder = false
        enableSubmit()
        utility.popBox '''
          <div style="text-align:left; padding: 20px;">
            <h4>Payment Status Unclear</h4>
            <p>We're still processing your payment. You should receive an email confirmation shortly.</p>
            <p>If you don't receive confirmation within 10 minutes, please contact support with order ID: ''' + orderId + '''</p>
          </div>
        '''
        return

      # Get CSRF token and merge with data
      csrfToken = utility.getCsrfToken()
      ajaxData = $.extend({ order_id: orderId }, csrfToken)
      $.ajax
        url: orderStatusURL
        method: 'POST'
        data: ajaxData
        dataType: 'json'
        timeout: 10000  # 10 second timeout for each request
        success: (response) ->
          # Connection restored - reset network error tracking
          consecutiveNetworkErrors = 0
          if networkWarningShown
            $('.modal-close-button').click()
            networkWarningShown = false
            showProcessingState()  # Restore normal processing message

          if response.success and response.redirect_url
            # Payment succeeded - redirect to thank you page
            # Clear order_id to prevent stale form resubmission on browser back
            $('input[name="order_id"]').val('')
            $('.modal-close-button').click()
            location.href = response.redirect_url
          else if response.error
            # Payment failed
            $processingOrder = false
            enableSubmit()
            $('.modal-close-button').click()

            # Check if tickets expired or refunded - prevent retry, clear order
            if response.expired or response.refunded
              $('input[name="order_id"]').val('')  # Clear order_id to force new order
              $('input[name="payment_intent_id"]').val('')  # Clear payment intent
              # Show message and refresh page to clear cart
              utility.popBox '''
                <div style="text-align:left; padding: 20px;">
                  <h4>Tickets Expired</h4>
                  <p>''' + (response.error_message || 'Your tickets have expired.') + '''</p>
                  <button onclick="location.reload()" class="btn btn-primary">Refresh Page</button>
                </div>
              ''', { persistent: true }
              return  # Don't allow retry

            # Regular error - allow retry
            errorMessage = response.error_message || 'Payment failed. Please try again.'
            cardErrors = document.getElementById('card-errors')
            if cardErrors
              cardErrors.textContent = errorMessage
            utility.popBox '<div style="text-align:left">' + errorMessage + '</div>'
          else if response.processing
            # Still processing - continue polling
            setTimeout(() ->
              pollOrderStatus(orderId, attemptCount + 1)
            , 1000)
          else
            # Unknown status
            $processingOrder = false
            enableSubmit()
            $('.modal-close-button').click()
            utility.popBox 'Unable to determine payment status. Please contact support.'
        error: (xhr, status, error) ->
          # Network error - retry with exponential backoff
          consecutiveNetworkErrors++

          # Show warning after 3 consecutive network errors (but keep trying)
          if consecutiveNetworkErrors >= 3 and !networkWarningShown
            networkWarningShown = true
            utility.popBox '''
              <div style="text-align:left; padding: 20px;">
                <h4>Connection Issue Detected</h4>
                <p><strong>You may have been disconnected from the internet.</strong></p>
                <p>Please check your internet connection. We'll keep trying to verify your payment...</p>
                <div style="margin-top: 15px;">
                  <div style="display: flex; align-items: center;">
                    <i class='ion-refresh animated slow repeat rotateIn' style="margin-right: 8px;"></i>
                    <span>Retrying connection...</span>
                  </div>
                </div>
              </div>
            ''', {
              persistent: true,
              showCloseButton: false
            }

          if attemptCount < maxPollAttempts
            backoffDelay = Math.min(1000 * Math.pow(2, attemptCount), 10000)
            setTimeout(() ->
              pollOrderStatus(orderId, attemptCount + 1)
            , backoffDelay)
          else
            $processingOrder = false
            enableSubmit()
            $('.modal-close-button').click()
            utility.popBox '''
              <div style="text-align:left; padding: 20px;">
                <h4>Network Connection Error</h4>
                <p><strong>You may have been disconnected from the internet.</strong></p>
                <p>Please check your internet connection and try again.</p>
                <p>If your payment was processed, you will receive an email confirmation. Please do not submit your order again until you verify whether your original payment succeeded.</p>
                <p>If you need assistance, please contact support.</p>
              </div>
            '''

    # Show processing state with better messaging
    showProcessingState = ->
      $submitButton.html '''
        <div style="display: flex; align-items: center; justify-content: center;">
          <i class='ion-refresh animated slow repeat rotateIn text-light bigger text-weight-bold'></i>
          <span style="margin-left: 8px;">Processing Payment...</span>
        </div>
      '''
      
      # Show informative processing message
      processingMessage = '''
        <div style="text-align: left; padding: 20px;">
          <h4>Processing Your Payment</h4>
          <p>Please wait while we securely process your payment. This usually takes just a few seconds.</p>
          <div style="margin-top: 15px;">
            <div style="display: flex; align-items: center;">
              <i class='ion-refresh animated slow repeat rotateIn' style="margin-right: 8px;"></i>
              <span>Confirming payment with your bank...</span>
            </div>
          </div>
        </div>
      '''
      utility.popBox processingMessage, {
        persistent: true,
        showCloseButton: false
      }

    disableSubmit = ->
      $submitButton.prop('disabled', true).addClass('ajax')
      $('button.paypal').prop('disabled', true).addClass('ajax')

    enableSubmit = ->
      $submitButton.html "<span>Place My Order</span>"
      $submitButton.removeClass('ajax').prop('disabled', false)
      $('button.paypal').removeClass('ajax').prop('disabled', false)
      $('.modal-close-button').click()

    # PayPal payment handler
    $('[js-cart-paypal]').on 'click', ->
      return if $processingOrder
      
      $processingOrder = true
      disableSubmit()
      
      # Clear any previous error messages
      cardErrors = document.getElementById('card-errors')
      if cardErrors
        cardErrors.textContent = ''

      # Get current order ID from form
      currentOrderId = $('input[name="order_id"]').val()

      if !currentOrderId
        $processingOrder = false
        enableSubmit()
        utility.popBox 'Unable to process order. Please refresh and try again.'
        return

      # Show processing state immediately
      # showProcessingState()
      
      # Make AJAX call to PayPal endpoint
      paypal_data = $form.serialize()
      paypal_data += "&action=paypal&payment_method=paypal"
      $.ajax
        url: saveURL 
        method: 'POST'
        data: paypal_data 
        dataType: 'json'
        success: (response) ->
          unless response.error and response.message
            if response.paymentURL
              location.href = response.paymentURL
            else
              enableSubmit()
              $processingOrder = false
              utility.popBox "We're sorry, but there was a problem with forwarding this order to PayPal..."
          else
            enableSubmit()
            $processingOrder = false
            utility.popBox "We're sorry, but there was a problem with forwarding this order to PayPal..."
        error: (response)->
          $processingOrder = false
          utility.popBox '<div style="text-align:left">' + response.responseText + '</div>'

    $('[js-cart-submit]').on 'click', ->
      $(this).focus()

    # Updated form submission with proper Promise handling
    $form.on 'submit', (e) ->
      e.preventDefault()
      unless $submitButton.is(':focus')
        $form.find(':focus').parents('section').find('[js-checkout-save]').trigger 'click'
      else
        if (!$processingOrder)
          $processingOrder = true
          disableSubmit()
          
          # Clear any previous error messages
          cardErrors = document.getElementById('card-errors')
          if cardErrors
            cardErrors.textContent = ''

          # Get current order ID from form
          currentOrderId = $('input[name="order_id"]').val()

          if !currentOrderId
            $processingOrder = false
            enableSubmit()
            utility.popBox 'Unable to process order. Please refresh and try again.'
            return

          # Reset network error tracking for new payment
          consecutiveNetworkErrors = 0
          networkWarningShown = false

          # Check if this is a zero-dollar order (no billing section = no payment required)
          if billing.$el.length == 0
            # Zero-dollar order - submit directly to backend
            # The hidden fields action=process_order and order_id are already in the form (from cart_totals.tpl)
            $.ajax
              url: saveURL
              method: 'POST'
              data: $form.serialize()
              dataType: 'json'
              success: (response) ->
                if response.paymentURL
                  window.location.href = response.paymentURL
                else if response.error
                  $processingOrder = false
                  enableSubmit()
                  utility.popBox '<div style="text-align:left">' + (response.message || 'Error processing order') + '</div>'
                else
                  $processingOrder = false
                  enableSubmit()
                  utility.popBox 'Unable to process order. Please try again.'
              error: (xhr, status, error) ->
                $processingOrder = false
                enableSubmit()
                utility.popBox 'An error occurred. Please try again.'
            return

          # Show processing state immediately
          showProcessingState()

          # Check if using legacy mode (token-based direct charge)
          useLegacy = $('input[name="use_legacy"]').val() == 'true' || window.STRIPE_USE_LEGACY

          if useLegacy
            # LEGACY MODE: Send raw card data to backend for server-side processing
            # This supports card readers where data is input directly

            # Prepare form data with raw card details
            formData =
              order_id: currentOrderId
              cc_number: $('input[name="cc_number"]').val()
              cc_code: $('input[name="cc_code"]').val()
              cc_Month: $('select[name="cc_Month"]').val()
              cc_Year: $('select[name="cc_Year"]').val()
              first_name: $('input[name="first_name"]').val()
              last_name: $('input[name="last_name"]').val()
              email: $('input[name="email"]').val()
              address: $('input[name="address"]').val()
              address2: $('input[name="address1"]').val()
              city: $('input[name="city"]').val()
              state: $('input[name="state"]').val()
              zip: $('input[name="zip"]').val()
              country: $('input[name="country"]').val()
              phone: $('input[name="phone"]').val()

            # POST to legacy payment endpoint (backend handles Stripe via PHP SDK)
            $.ajax
              url: '/order/process_legacy_stripe_payment'
              method: 'POST'
              data: formData
              dataType: 'json'
              success: (response) ->
                if response.error
                  # Payment failed
                  $processingOrder = false
                  enableSubmit()
                  cardErrors = document.getElementById('card-errors')
                  if cardErrors
                    cardErrors.textContent = response.message
                  utility.popBox '<div style="text-align:left">' + response.message + '</div>'
                else
                  # Payment succeeded - redirect to confirmation
                  window.location.href = response.redirect_url
              error: (xhr, status, error) ->
                $processingOrder = false
                enableSubmit()
                errorMessage = 'An error occurred processing your payment. Please try again.'
                cardErrors = document.getElementById('card-errors')
                if cardErrors
                  cardErrors.textContent = errorMessage
                utility.popBox '<div style="text-align:left">' + errorMessage + '</div>'

          else
            # MODERN MODE: Use PaymentIntent with webhook
            # Confirm the PaymentIntent with Stripe using Promises
            stripe.confirmPayment({
              elements: elements,
              redirect: 'if_required'
            }).then (result) ->
              if result.error
                # Payment failed immediately
                $processingOrder = false
                enableSubmit()

                errorMessage = result.error.message || 'An error occurred while processing your payment.'
                cardErrors = document.getElementById('card-errors')
                if cardErrors
                  cardErrors.textContent = errorMessage
                utility.popBox '<div style="text-align:left">' + errorMessage + '</div>'
              else
                # Payment submitted successfully - start polling
                paymentIntent = result.paymentIntent

                if paymentIntent.status is 'succeeded'
                  # Payment completed immediately - start polling to ensure server processed it
                  pollOrderStatus(currentOrderId)
                else if paymentIntent.status is 'processing'
                  # Payment is being processed - start polling
                  pollOrderStatus(currentOrderId)
                else if paymentIntent.status is 'requires_action'
                  # Additional authentication required
                  $processingOrder = false
                  enableSubmit()
                  utility.popBox '''
                    <div style="text-align:left">
                      <h4>Additional Verification Required</h4>
                      <p>Your payment requires additional verification. Please complete the authentication and try again.</p>
                    </div>
                  '''
                else
                  # Unknown status
                  $processingOrder = false
                  enableSubmit()
                  utility.popBox '''
                    <div style="text-align:left">
                      <h4>Payment Status Unknown</h4>
                      <p>We're unsure about your payment status. Please contact support if you believe this transaction should have succeeded.</p>
                    </div>
                  '''
            .catch (error) ->
              # Check if error is "already succeeded" - happens when webhook processes faster than frontend
              # In this case, payment actually succeeded, we just need to poll to verify
              isAlreadySucceeded = error.type is 'invalid_request_error' or
                                   error.code is 'payment_intent_unexpected_state' or
                                   error.message?.includes('already succeeded') or
                                   error.message?.includes('has already been confirmed')

              if isAlreadySucceeded
                # Don't show error, don't reset form - just poll to check actual status
                pollOrderStatus(currentOrderId)
              else
                # Real error - show message and allow retry
                $processingOrder = false
                enableSubmit()
                utility.popBox '''
                  <div style="text-align:left">
                    <h4>Unexpected Error</h4>
                    <p>An unexpected error occurred while processing your payment. Please try again.</p>
                  </div>
                '''

  if $('[js-checkout]')
    checkoutPage()

$ ->
  ticketingForm = ->
    $form = $('[js-ticketing]')
    url = "/sell/edit_ajax"

    $saveButtons = $('[js-ticketing-save]')
    $allInputs = $form.find('input, select')
    $hiddenAction = $('[name="action"]')
    $fileFields = $form.find('[js-image-upload]')
    $sections = $('[js-ticketing-step]')
    $accordionTogglerButton = $('.tf-toggler-button')
    $jsPaymentMethod = $('[js-payment-method]')

    $jsPaymentMethod.on "change", ->
      $(".js-is-ach").each ->
        if ($(this).hasClass('d-none'))
          $(this).removeClass('d-none')
        else
          $(this).addClass('d-none')
        $(window).trigger('resize')

    $fileFields.each ->
      $file = $(this)
      fileUrl = $file.attr('js-image-upload')
      $status = $file.siblings('small')
      $img = $file.siblings('.preview')
      $button = $file.parent().parent().next().find 'button'
      name = $file.attr('name')

      $button.on "click", (e)->
        e.preventDefault()
        $file.trigger "click"
        # console.log 'click'

      $file.on "change", ->
        data = new FormData()
        data.append name, $file.prop('files')[0]
        # Add CSRF token to FormData
        csrfToken = utility.getCsrfToken()
        for key, value of csrfToken
          data.append key, value
        $img.css
            opacity: 0
        $status.addClass 'ajax'
        $button.prop 'disabled', true
        $.ajax
          url: fileUrl
          data: data
          type: 'POST'
          cache: false
          dataType: 'json'
          processData: false
          contentType: false
          success: (results)->
            if (results.data && results.success == true)
                $status.text "Upload Done"
                $newImg = $('<img>')
                $newImg.on 'load', ->
                  $newImg.remove()
                  $img.css
                    backgroundImage: 'url(' + results.data.event_image + ')'
                  $img.animate
                    opacity: 1
                  , 1000
                $newImg.attr 'src', results.data.event_image
                return
             if (results.data && results.data.error && results.success != true)
                 utility.popBox results.data.error
                return
             utility.popBox "There was an issue with the upload.  Please try again."
          error: (response)->
            $status.removeClass 'ajax'
            utility.popBox "Upload Error"
            $button.prop 'disabled', false
          complete: ->
            $button.prop 'disabled', false

    doAjax = (i)->
      final = i == $sections.length-1
      if final
        $hiddenAction.val "send"
      $.ajax
        url: url
        data: $form.find('[name]').not(':file').serialize()
        method: 'post'
        dataType: 'json'
        success: (response)->
          if response.data != null
            passes = utility.caffelliServerValidateField $sections.eq(i), response.data
          if response.message == "event submitted"
            passes = 1
            final = 1
          if passes and not final
            $nextSection = $sections.eq(i+1)
            $currentSectionToggler = $accordionTogglerButton.eq(i)
            $nextSectionToggler = $accordionTogglerButton.eq(i + 1)
            
            $("html, body").animate
              scrollTop: $nextSection.offset().top - 100
            , 300

            setTimeout(() ->
              $nextSection.removeClass "locked-form"
              if !$nextSection.hasClass "show-details"
                $nextSectionToggler.trigger "click"
              if $nextSection.hasClass "show-details"
                $currentSectionToggler.trigger "click"
            , 300)

          else if passes
            # console.log "tried to redirect"
            location.href = "/ticket-my-event/thankyou"
          else
            utility.setAccordionFormStyles()
        complete: ->
          $hiddenAction.val ""

    $saveButtons.each (i)->
      $(this).on 'click', (e)->
        e.preventDefault()

        doAjax i

    $allInputs.on 'keydown', (e)->
      if e.keyCode == 13
        e.preventDefault()
        e.stopPropagation()
        $section = $(this).parents('section').find('[js-ticketing-save]').trigger 'click'
        return false

    $form.on 'submit', (e)->
      e.preventDefault()

  if $('[js-ticketing]')
    ticketingForm()

$ ->

	window.seatingChart = ->
		$seats = $('[js-seatingchart-seat]')
		$totalTickets = $('[js-seatingchart-requested]')
		$totalPrice = $('[js-seatingchart-totalprice]')
		$categories = $('[js-seating-map-category]')

		$formSeatIDs = $("[name='seatIds']")
		$formSubmit = $("[name='submit_cat']")

		# customer immersive picker chrome (absent in the box-office inhouse view)
		$overlay = $('.sp-overlay')
		$tray = $('#sp-tray')
		trayMode = $tray.length > 0

		selectedSeats = {}   # seat_id -> price   (source of truth for both modes)
		seatEls = {}         # seat_id -> $seat
		seatLabels = {}      # seat_id -> human label for the boarding-pass stub

		# category id -> price (drives the running total) and -> colour (additive tint)
		categoryData = []
		categoryColor = []
		$categories.each ->
			id = $(this).attr('js-seating-map-category')
			price = parseFloat $(this).find('span').first().text().replace(/[^-0-9.]/g, "")
			categoryData[id] = price
			categoryColor[id] = $(this).find('.key-color').css('background-color')

		# ---------- boarding-pass tray ----------
		$stubs = $('#sp-stubs')
		$cart = $('#sp-cart')
		$countN = $('#sp-countN')
		$countLbl = $('#sp-countLbl')
		$handleTotal = $('#sp-handle-total')
		$hint = $('#sp-hint')
		$cartSub = $('#sp-cartsub')
		userCollapsed = false

		setTray = (open)->
			$tray.toggleClass 'open', open
			$('#sp-handle').attr 'aria-expanded', (if open then 'true' else 'false')

		renderTray = ->
			return unless trayMode
			ids = Object.keys selectedSeats
			n = ids.length
			total = 0
			total += selectedSeats[k] for k in ids
			$countN.text n
			$countLbl.text (if n == 0 then 'Tap a seat to begin' else (if n == 1 then 'seat selected' else 'seats selected'))
			$handleTotal.text (if n then utility.priceFormat(total, true) else '')
			if n then $hint.hide() else $hint.show()
			$stubs.empty()
			ordered = ids.sort (a, b)-> (seatLabels[a] or a).localeCompare (seatLabels[b] or b), undefined, {numeric: true}
			for id in ordered
				do (id)->
					label = seatLabels[id] or id
					$stub = $('<div class="sp-stub"></div>')
					$stub.append $('<div class="code"></div>').text(label)
					$stub.append $('<div class="price"></div>').text(utility.priceFormat(selectedSeats[id], true))
					$rm = $('<button type="button" class="rm" aria-label="Remove seat"></button>').html('&times;')
					$rm.on 'click', (e)->
						e.preventDefault()
						e.stopPropagation()
						deselectSeat id
					$stub.append $rm
					$stubs.append $stub
			if n then $cart.show() else $cart.hide()
			$cartSub.text (if n then (' · ' + utility.priceFormat(total, true) + ' · ' + n + ' ' + (if n == 1 then 'ticket' else 'tickets')) else '')
			# Emptying the selection must NOT collapse the tray. The tray defaults open and
			# only the handle closes it; auto-collapsing on n==0 turned a mis-aimed tap
			# (which can deselect your only seat down to zero) into a jarring tray slam +
			# lost seat. Reset userCollapsed so a later pick re-opens cleanly, but leave the
			# open/closed state to the user.
			if n == 0
				userCollapsed = false

		# ---------- selection state (cart contract preserved exactly) ----------
		updateTotals = ->
			totalTickets = Object.keys(selectedSeats).length
			$totalTickets.text totalTickets
			if totalTickets
				totalPrice = 0
				totalPrice += val for key, val of selectedSeats
				$formSubmit.prop('disabled', false)
			else
				totalPrice = 0
				$formSubmit.prop('disabled', true)
			$totalPrice.text utility.priceFormat totalPrice, true
			$formSeatIDs.val (key for key, val of selectedSeats).join(',')
			renderTray()

		addTicket = (price, seatID)->
			selectedSeats[seatID] = price
			updateTotals()

		removeTicket = (seatID)->
			delete selectedSeats[seatID]
			updateTotals()

		selectSeatEl = ($seat, id, price)->
			$seat.addClass 'selected'
			if trayMode
				$seat.addClass 'sp-pop'
				$seat.one 'animationend', -> $seat.removeClass 'sp-pop'
				if not userCollapsed then setTray true
			addTicket price, id

		deselectSeatEl = ($seat, id)->
			$seat.removeClass 'selected'
			removeTicket id

		deselectSeat = (id)->
			$seat = seatEls[id]
			if $seat and $seat.length then deselectSeatEl $seat, id else removeTicket id

		# ---------- pan / zoom ----------
		viewport = document.getElementById('sp-viewport')
		mapEl = document.getElementById('sp-map')
		overlayEl = if $overlay.length then $overlay.get(0) else null

		toggleSeatEl = ($seat)->
			seatData = $seat.attr('js-seatingchart-seat').split('|')
			category = seatData[1]
			id = seatData[2]
			price = categoryData[category]
			if selectedSeats[id]?
				deselectSeatEl $seat, id
			else
				selectSeatEl $seat, id, price

		if viewport and mapEl
			# Pan/zoom/FIT now lives in the ONE shared engine both twins load
			# (public_html/js/seat_pan_zoom.js), so a fix reaches the storefront and the box
			# office together instead of one twin at a time. Storefront adapter: contain-fit
			# (never upscale past 1), the mobile MIN=0.1 floor, capture-mode gestures WITH
			# 2-finger pinch, the .zoomed-out class below 0.62, and selection via the onTap
			# callback — toggleSeatEl (defined above) still owns select/deselect + the tray.
			if not window.SeatPanZoom
				console.error '[sp-zoom] seat_pan_zoom.js not loaded — storefront pan/zoom disabled' if window.console
			else
				window.SeatPanZoom.init (overlayEl or viewport),
					viewportEl: viewport
					mapEl: mapEl
					zin: 'sp-zin'
					zout: 'sp-zout'
					zfit: 'sp-zfit'
					notice: 'sp-notice'
					min: 0.1
					fitMode: 'contain'
					padTop: 96
					padBottom: 86
					gestureMode: 'capture'
					zoomedOutClass: 'zoomed-out'
					zoomedOutBelow: 0.62
					onTap: (seatEl)-> toggleSeatEl $(seatEl)

		# ---------- per-seat wiring ----------
		$seats.each ->
			$seat = $(@)
			seatData = $seat.attr('js-seatingchart-seat').split('|')
			category = seatData[1]
			id = seatData[2]
			price = categoryData[category]
			isAvailable = $seat.hasClass 'available'

			seatEls[id] = $seat
			seatLabels[id] = $seat.attr('data-sp-seatlabel') or id

			# additive per-category colour so multi-tier sections keep their tier colour;
			# selection layers a red ring on top (see .sp-overlay .seat.selected in scss)
			if isAvailable and categoryColor[category]
				$seat.get(0).style.setProperty '--sp-cat', categoryColor[category]

			$hoverTimer = null
			$seat.on 'mouseenter', (e)->
				$hoverTimer = setTimeout ->
					$seat.addClass 'showtip'
				, 300

			$seat.on 'mouseleave', (e)->
				if $hoverTimer
					clearTimeout $hoverTimer
				$seat.removeClass 'showtip'

			# In the immersive picker, taps are resolved by the pan/zoom pointer handler
			# (drag vs tap). The legacy box-office view keeps the plain click binding.
			if not trayMode
				$seat.on 'click', (e)->
					if isAvailable and not selectedSeats[id]?
						selectSeatEl $seat, id, price
					else if isAvailable and selectedSeats[id]?
						deselectSeatEl $seat, id

		# ---------- tray handle + close (customer only) ----------
		if trayMode
			$handle = $('#sp-handle')
			$handle.on 'click', ->
				willOpen = not $tray.hasClass('open')
				userCollapsed = not willOpen
				setTray willOpen
			$handle.on 'keydown', (e)->
				if e.key == 'Enter' or e.key == ' '
					e.preventDefault()
					$handle.trigger 'click'
			$('#sp-close').on 'click', (e)->
				e.preventDefault()
				$btn = $('.modal-close-button')
				if $btn.length then $btn.trigger('click') else utility.popBox()

		return

ControlHelper = 

    printOrder: (order_id, opts) ->
        if !order_id
            alert('Error: no order id specified')
            return false

        if typeof opts == 'undefined'
            opts = {}

        printReceipt = 0

        if typeof opts.receipt != 'undefined'
            printReceipt = parseInt opts.receipt
        else
            printReceipt = if confirm('Do you want a receipt?') then 1 else 0

        boca = 0
        if typeof opts.boca != 'undefined'
            boca = parseInt opts.boca 
        else
            boca = if confirm('Are you printing on 5.5" x 2" paper?\r\n[ Cancel prints a normal ticket ]') then 1 else 0

        url = '/view-order/' + parseInt order_id
        if boca
            url += '/boca'
        if printReceipt
            url += '?receipt=yes'

        window.open url, '_blank'
        return

$ ->
    'use strict'

    MainApp = ->
        @$body = $('body')
        @$wrapper = $('#wrapper')
        @$btnFullScreen = $('#btn-fullscreen')
        @$leftMenuButton = $('.button-menu-mobile')
        @$menuItem = $('.has_sub > a')
        return

    MainApp::initSlimscroll = ->
        $('.slimscrollleft').slimscroll
            height: '100%'
            position: 'right'
            size: '10px'
            color: '#9ea5ab'
        return

    MainApp::initLeftMenuCollapse = ->
        $this = this
        @$leftMenuButton.on 'click', (event) ->
            event.preventDefault()
            $this.$body.toggleClass 'fixed-left-void'
            $this.$wrapper.toggleClass 'enlarged'
            return
        return

    MainApp::initComponents = ->
        $('[data-toggle="tooltip"]').tooltip()
        $('[data-toggle="popover"]').popover()
        return

    MainApp::initFullScreen = ->
        $this = this
        $this.$btnFullScreen.on 'click', (e) ->
            e.preventDefault()
            if !document.fullscreenElement and !document.mozFullScreenElement and !document.webkitFullscreenElement
                # current working methods
                if document.documentElement.requestFullscreen
                    document.documentElement.requestFullscreen()
                else if document.documentElement.mozRequestFullScreen
                    document.documentElement.mozRequestFullScreen()
                else if document.documentElement.webkitRequestFullscreen
                    document.documentElement.webkitRequestFullscreen Element.ALLOW_KEYBOARD_INPUT
                else
                if document.cancelFullScreen
                    document.cancelFullScreen()
                else if document.mozCancelFullScreen
                    document.mozCancelFullScreen()
                else if document.webkitCancelFullScreen
                    document.webkitCancelFullScreen()
                return
        return

    MainApp::initMenu = ->
        $this = this
        #inner functions

        visibleSubMenuClose = ->
            $('.has_sub').each ->
                t = $(this)
                if t.hasClass('nav-active')
                    t.find('> ul').slideUp 300, ->
                        t.removeClass 'nav-active'
                        return
                return
            return

        adjustMainContentHeight = ->
            # Adjust main content height
            docHeight = $(document).height()
            if docHeight > $('.body-content').height()
                $('.body-content').height docHeight
            return

        $this.$menuItem.on 'click', ->
            parent = $(this).parent()
            sub = parent.find('> ul')
            if !$this.$body.hasClass('sidebar-collapsed')
                if sub.is(':visible')
                    sub.slideUp 300, ->
                        parent.removeClass 'nav-active'
                        $('.body-content').css height: ''
                        adjustMainContentHeight()
                        return
                else
                    visibleSubMenuClose()
                    parent.addClass 'nav-active'
                    sub.slideDown 300, ->
                        adjustMainContentHeight()
                        return
                false
        return

    MainApp::activateMenuItem = ->
        # === following js will activate the menu in left side bar based on url ====
        $('#sidebar-menu a').each ->
            pageUrl = window.location.href.split(/[?#]/)[0]
            if @href == pageUrl
                $(this).addClass 'active'
                $(this).parent().addClass 'active'
                # add active to li of the current link
                $(this).parent().parent().prev().addClass 'active'
                # add active class to an anchor
                $(this).parent().parent().parent().addClass 'active'
                # add active class to an anchor
                $(this).parent().parent().prev().click()
                # click the item to make it drop
                return
             return
        return

    MainApp::Preloader = ->
        window.addEventListener 'load', ->
            $('#status').fadeOut()
            $('#preloader').delay(350).fadeOut 'slow'
            $('body').delay(350).css 'overflow': 'visible'
            return
        return

    MainApp::ToggleSearch = ->
        $('.toggle-search').on 'click', ->
            targetId = $(this).data('target')
            $searchBar = undefined
            if targetId
                $searchBar = $(targetId)
                $searchBar.toggleClass 'open'
                return
            return
        return
        
    MainApp::initNavbar = ->
        $('.navbar-toggle').on 'click', (event) ->
            $(this).toggleClass 'open'
            $('#navigation').slideToggle 400
            return
        $('.navigation-menu>li').slice(-1).addClass 'last-elements'
        $('.navigation-menu li.has-submenu a[href="#"]').on 'click', (e) ->
            if $(window).width() < 992
                e.preventDefault()
                $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass 'open'
            return
        return

    MainApp::initLoader = ->
        $(window).on 'load', ->
            $('#status').fadeOut()
            $('#preloader').delay(350).fadeOut 'slow'
            $('body').delay(350).css 'overflow': 'visible'
            return
        return

    MainApp::initScrollbar = ->
        $('.slimscroll-noti').slimScroll
            height: '230px'
            position: 'right'
            size: '5px'
            color: '#98a6ad'
            wheelStep: 10
        return

    # === fo,llowing js will activate the menu in left side bar based on url ====

    MainApp::initMenuItem = ->
        $('.navigation-menu a').each ->
            pageUrl = window.location.href.split(/[?#]/)[0]
            if @href == pageUrl
                $(this).parent().addClass 'active'
                # add active to li of the current link
                $(this).parent().parent().parent().addClass 'active'
                # add active class to an anchor
                $(this).parent().parent().parent().parent().parent().addClass 'active'
                # add active class to an anchor
                return
            return
        return

    MainApp::initComponents = ->
        $('[data-toggle="tooltip"]').tooltip()
        $('[data-toggle="popover"]').popover()
        $(".bootstrap-select-search").selectpicker()
        $(".bootstrap-select").selectpicker(
           liveSearch: false  
        )
        return

    

    MainApp::initToggleSearch = ->
        $('.toggle-search').on 'click', ->
            targetId = $(this).data('target')
            $searchBar = undefined
            if targetId
                $searchBar = $(targetId)
                $searchBar.toggleClass 'open'
                return
            return
        return

    MainApp::init = ->
        @initSlimscroll()
        @initLeftMenuCollapse()
        @initComponents()
        @initFullScreen()
        @initMenu()
        @activateMenuItem()
        @Preloader()
        @ToggleSearch()
        @initNavbar()
        @initLoader()
        @initScrollbar()
        @initMenuItem()
        @initComponents()
        @initToggleSearch()
        return

    $.MainApp = new MainApp
    $.MainApp.Constructor = MainApp
    
    if typeof $().slimscroll != "undefined"
        $.MainApp.init()

    AdvancedForm = ->
        @$datepicker = false 
        return
        
    AdvancedForm::init = ->
        if @$datepicker
            @$datepicker.each (index) ->
                $(this).data("DateTimePicker").destroy()
                return
        if $('.admin-datepicker').length   
            @$datepicker = $('.admin-datepicker').datetimepicker
                format: "YYYY-MM-DD"
        return

    $.AdvancedForm = new AdvancedForm
    $.AdvancedForm.Constructor = AdvancedForm

    #window.console.log 'dashboard js loaded now'
    dashboard = ->

        statURL = "/dashboard/stats_ajax/"
        c_green = [
            "#3C4E1C"
            "#4C6124"
            "#5B752B"
            "#6A8832"
            "#799C39"
            "#88AF40"
            "#98C348"
            "#A2C95A"
            "#ACCF6C"
            "#B6D57E"
            "#C1DB91"
            "#CBE1A3"
            "#D5E7B5"
            "#E0EDC8"
            "#EAF3DA"
            "#F4F9EC"
        ]
        c_blue = [
            "#2A576C"
            "#3F677A"
            "#547889"
            "#698998"
            "#7F9AA6"
            "#94ABB5"
            "#A9BBC4"
            "#BFCCD2"
            "#D4DDE1"
            "#E9EEF0"
            "#10222B"
            "#152B36"
            "#193440"
            "#1D3C4B"
            "#214556"
        ]
        c_red = [
            "#661910"
            "#753027"
            "#84473F"
            "#935E57"
            "#A3756F"
            "#B28C87"
            "#C1A39F"
            "#D1BAB7"
            "#E0D1CF"
            "#EFE8E7"
        ]
        selectable_change = 0
        active_users_processing = 0

        $expander = $("thead[data-toggle='collapse']")
        $expander.on 'click', (e) ->
            $(this).find("span:contains('+')").toggleClass 'hide'
            $(this).find("span:contains('-')").toggleClass 'hide'
            return

        $daterange = $("#date-range").find("input")
        $daterange.on 'dp.change', (e) ->
            start_date = $("input[name=start_date]").val()
            end_date = $("input[name=end_date]").val()
            event_id = $("#date-range").attr("js-event-id")
            $.getJSON statURL + "?action=transaction_line_chart&event_id=" + event_id + "&start_date=" + start_date + "&end_date=" + end_date
                .done (response) ->
                    drawCharts response
            return 

        $.fn.editableform.buttons = '<button type="submit" class="btn btn-success editable-submit btn-sm waves-effect waves-light"><i class="mdi mdi-check"></i></button>' + '<button type="button" class="btn btn-danger editable-cancel btn-sm waves-effect waves-light"><i class="mdi mdi-close"></i></button>'

        $('#inline-facebook-pixel').editable
            type: 'text'
            url: statURL + "?action=event_update&event_id=" + $('#inline-facebook-pixel').attr("js-event") 
            name: 'event_fbpixel'
            title: 'Enter your Facebook Pixel'
            mode: 'inline'
            inputclass: 'form-control-sm'
            success: (response, newValue) ->
                # window.console.log response
                return  

        $('#inline-google-code').editable
            type: 'text'
            url: statURL + "?action=event_update&event_id=" + $('#inline-facebook-pixel').attr("js-event") 
            name: 'event_googlecode'
            title: 'Enter your Google Tracking ID'
            mode: 'inline'
            inputclass: 'form-control-sm'
            success: (response, newValue) ->
                # window.console.log response
                return

        setupCouponEditorActions = ->
            $couponEditorItem = $("a[data-target='#couponEditor']")
            $couponEditorItem.on 'click', (e) ->
                if $(this).attr('js-event')
                    $('#couponEditorLabel').html("Coupon Editor")
                    cei_category = $(this).attr('js-category')
                    cei_selected =$('form[name=coupon_editor] select[name=coupon_event_id]').val() 
                    $('form[name=coupon_editor] select[name=coupon_event_id]').val($(this).attr('js-event')).trigger('change') 
                    $('form[name=coupon_editor] input[name=coupon_id]').val($(this).attr('js-coupon')) 
                    $('form[name=coupon_editor] select[name=coupon_active]').val($(this).attr('js-active')).trigger('change') 
                    $('form[name=coupon_editor] input[name=coupon_code]').val($(this).attr('js-code')) 
                    $('form[name=coupon_editor] select[name=coupon_discount_type]').val($(this).attr('js-type')).trigger('change')
                    cei_amount = if parseInt($(this).attr('js-type')) == 0 then parseFloat($(this).attr('js-amount')) * 100 else $(this).attr('js-amount')
                    $('form[name=coupon_editor] input[name=coupon_discount_percentage]').val(cei_amount)
                    cei_start = if $(this).attr('js-start') == "0000-00-00" then "" else $(this).attr('js-start') 
                    cei_end = if $(this).attr('js-end') == "0000-00-00" then "" else $(this).attr('js-end')
                    $('form[name=coupon_editor] input[name=coupon_start_date]').val(cei_start) 
                    $('form[name=coupon_editor] input[name=coupon_end_date]').val(cei_end)
                    $.AdvancedForm.init()
                    $('form[name=coupon_editor] input[name=coupon_max_uses]').val($(this).attr('js-max'))
                    $('form[name=coupon_editor] select[name=coupon_category_id]').val(cei_category).trigger('change')
                else
                    $('#couponEditorLabel').html("Create a Coupon")
                    $('form[name=coupon_editor] input[name=coupon_id]').val("") 
                    $('form[name=coupon_editor] select[name=coupon_active]').val(0).trigger('change') 
                    $('form[name=coupon_editor] input[name=coupon_code]').val("") 
                    $('form[name=coupon_editor] select[name=coupon_discount_type]').val(0).trigger('change')
                    $('form[name=coupon_editor] input[name=coupon_discount_percentage]').val("")
                    $('form[name=coupon_editor] input[name=coupon_start_date]').val("")  
                    $('form[name=coupon_editor] input[name=coupon_end_date]').val("")
                    $.AdvancedForm.init()
                    $('form[name=coupon_editor] input[name=coupon_max_uses]').val("")
                    $('form[name=coupon_editor] select[name=coupon_category_id]').val("").trigger('change')
                return  
           
            $couponEventSelector = $("form[name=coupon_editor] select[name=coupon_event_id]")
            $couponEventSelector.on 'change', (e) ->
                ces_selected = $('form[name=coupon_editor] select[name=coupon_event_id]').val()
                $.getJSON statURL + "?action=category_selector&event_id=" + ces_selected
                    .done (response) ->
                        if (response.length)
                            cei_currently_selected_category = $('form[name=coupon_editor] select[name=coupon_category_id]').val()
                            $('select[name=coupon_category_id]').find('option').remove()
                            $('select[name=coupon_category_id]').append new Option("All Categories", 0)
                            for i in [0...response.length]
                                $('select[name=coupon_category_id]').append new Option(response[i]["name"], response[i]["id"])
                            $('select[name=coupon_category_id]').selectpicker('refresh')
                            $('form[name=coupon_editor] select[name=coupon_category_id]').val(cei_currently_selected_category).trigger('change')
                return

            $("#couponEditorSubmit").on 'click', (e) ->
                $("form[name=coupon_editor]").submit()
                
            $("[js-button='couponEditorSubmit']").on 'click', (e) ->
                $("input[name=action]").val "save"
                $("form[name=coupon_editor]").submit()
                return

            $("[js-button='couponEditorDelete']").on 'click', (e) ->
                $("[js-button='couponEditorClose'").addClass "d-none"
                $("[js-button='couponEditorSubmit'").addClass "d-none"
                $("[js-button='couponEditorDelete'").addClass "d-none"
                $("[js-button='couponEditorCancel'").removeClass "d-none"
                $("[js-button='couponEditorConfirm'").removeClass "d-none"
                return

            $("[js-button='couponEditorCancel']").on 'click', (e) ->
                $("[js-button='couponEditorClose'").removeClass "d-none"
                $("[js-button='couponEditorSubmit'").removeClass "d-none"
                $("[js-button='couponEditorDelete'").removeClass "d-none"
                $("[js-button='couponEditorCancel'").addClass "d-none"
                $("[js-button='couponEditorConfirm'").addClass "d-none"
                return

            $("[js-button='couponEditorConfirm']").on 'click', (e) ->
                $("input[name=action]").val "delete"
                $("form[name=coupon_editor]").submit()
                return

            return

        drawMorrisArea = (element_id, table_data, title, format) ->
            if table_data[2].length
                if typeof Morris != 'undefined' && $("#"+element_id).length
                    $("#"+element_id).empty()
                    Morris.Area
                        element: element_id
                        lineColors: c_red
                        data: table_data[2]
                        xkey: 'y'
                        ykeys: table_data[0]
                        labels: table_data[1]
                        resize: true
                        hideHover: 'auto'
                        gridLineColor: '#eeeeee'
                        fillOpacity: .6
                        pontSize: 0
                        lineWidth: 0
                        behaveLikeLine: true
            else
                $("#"+element_id).empty()
                $("#"+element_id).html "There is no data available at this time."
            return

        drawMorrisBar = (element_id, table_data, title, format) ->
            if table_data[2].length
                if typeof Morris != 'undefined' && $("#"+element_id).length
                    $("#"+element_id).empty()
                    Morris.Bar
                        element: element_id
                        barColors: c_green
                        data: table_data[2]
                        xkey: 'y'
                        ykeys: table_data[0]
                        labels: table_data[1]
                        resize: true
                        hideHover: 'auto'
                        barSizeRatio: 0.4
                        gridLineColor: '#eeeeee'
                else
                    $("#"+element_id).empty()
                    $("#"+element_id).html "There is no data available at this time."
            return

        drawMorrisDonut = (element_id, table_data, title, format) ->
            if table_data[2].length
                if typeof Morris != 'undefined' && $("#"+element_id).length
                    $("#"+element_id).empty()
                    Morris.Donut
                        element: element_id
                        colors: c_blue
                        data: table_data[2]
                        resize: true
                        formatter: (y) ->
                            if format
                                if format == "pretty"
                                    return parseFloat(y).toLocaleString('en')
                                else
                                    return '$' + parseFloat(y).toLocaleString('en', {minimumFractionDigits: 2})
                            else
                                return y 
                    if title then $("#"+element_id).prev().html title
            else
                $("#"+element_id).empty()
                $("#"+element_id).html "There is no data available at this time."
            return

        drawMorrisLine = (element_id, table_data, title, format) ->
            if table_data[2].length 
                if typeof Morris != 'undefined' && $("#"+element_id).length
                    $("#"+element_id).empty()
                    Morris.Line
                        element: element_id
                        lineColors: ['#2A576C', 'transparent']
                        data: table_data[2]
                        xkey: 'y'
                        ykeys: table_data[0]
                        labels: table_data[1]
                        resize: true
                        hideHover: 'auto'
                        gridLineColor: '#eeeeee'
                        lineWidth: 2
            else
                $("#"+element_id).empty()
                $("#"+element_id).html "There is no data available at this time."
            return

        drawCharts = (chartdata) ->
            for i in [0...chartdata.length]
                switch
                    when chartdata[i]['type'] == "area" then drawMorrisArea "morris-area-"+chartdata[i]['id'], chartdata[i]['data'], chartdata[i]['title'], chartdata[i]['format']
                    when chartdata[i]['type'] == "bar" then drawMorrisBar "morris-bar-"+chartdata[i]['id'], chartdata[i]['data'], chartdata[i]['title'], chartdata[i]['format']
                    when chartdata[i]['type'] == "donut" then drawMorrisDonut "morris-donut-"+chartdata[i]['id'], chartdata[i]['data'], chartdata[i]['title'], chartdata[i]['format']
                    when chartdata[i]['type'] == "line" then drawMorrisLine "morris-line-"+chartdata[i]['id'], chartdata[i]['data'], chartdata[i]['title'], chartdata[i]['format']
            return

        loadMainDashTransactionGraph = (lmdat) ->
            drawMorrisLine "dashboard-transaction-graph",lmdat 
            return

        loadMainDashActiveUsers = ->
            processActiveUsers()
            active_interval = setInterval (->
                if !active_users_processing
                    processActiveUsers() 
                    return 
                return
            ), 20000
            return

        processActiveUsers = ->
            event_id = $("#dashboard-active-users").attr("js-event-id")
            active_users_processing = 1
            $.getJSON statURL + "?action=analytics&event_id=" + event_id + "&type=active"
                .done (response) ->
                    active = 0
                    if response.length
                        active = response[0]['active']
                        $("#dashboard-active-users").html active 
                    active_users_processing = 0
                    return
            return

        loadMainDashSessionsGraph = ->
            total_traffic = [0,0]
            direct_traffic = [0,0] 
            referral_traffic = [0,0] 
            organic_traffic = [0,0]
            social_traffic = [0,0] 
            other_traffic = [0,0] 
            event_id = $("#dashboard-session-chart").attr("js-event-id")
            start_date = $("#dashboard-session-chart").attr("js-start-date")
            end_date = $("#dashboard-session-chart").attr("js-end-date")
            if start_date.length > 1 && end_date.length > 1
                $.getJSON statURL + "?action=analytics&event_id=" + event_id + "&start_date=" + start_date + "&end_date=" + end_date
                    .done (response) ->
                        if response.length
                            for i in [0...response.length]
                                switch 
                                    when response[i][0].toLowerCase().indexOf("direct") >= 0 then direct_traffic[0] = direct_traffic[0] + parseInt response[i][2]
                                    when response[i][0].toLowerCase().indexOf("organic") >= 0 then organic_traffic[0] = organic_traffic[0] + parseInt response[i][2]
                                    when response[i][0].toLowerCase().indexOf("facebook") >= 0 then social_traffic[0] = social_traffic[0] + parseInt response[i][2]
                                    when response[i][0].toLowerCase().indexOf("twitter") >= 0 then social_traffic[0] = social_traffic[0] + parseInt response[i][2]
                                    when response[i][0].toLowerCase().indexOf("instagram") >= 0 then social_traffic[0] = social_traffic[0] + parseInt response[i][2]
                                    when response[i][0].toLowerCase().indexOf("referral") >= 0 then referral_traffic[0] = referral_traffic[0] + parseInt response[i][2]
                                    else other_traffic[0] = other_traffic[0] + parseInt response[i][2]
                                total_traffic[0] = total_traffic[0] + parseInt response[i][2]
                            $("#dashboard-unique-visitors").html total_traffic[0].toLocaleString()
                            table_data = [] 
                            table_data[2] = [
                                {
                                    'label': "Direct"
                                    'value': direct_traffic[0]
                                }
                                {
                                    'label': "Referral"
                                    'value': referral_traffic[0]
                                }
                                {
                                    'label': "Organic"
                                    'value': organic_traffic[0]
                                }
                                {
                                    'label': "Social"
                                    'value': social_traffic[0]
                                }
                                {
                                    'label': "Other"
                                    'value': other_traffic[0]
                                }
                            ]
                            drawMorrisDonut "dashboard-session-chart", table_data, "Sessions", "pretty" 
                            # window.console.log response
                        else
                            $("#dashboard-session-chart").prev().html "No session data is avialable yet..."
            else
                $("#dashboard-session-chart").prev().html "No session data is avialable yet..."
            return

        loadActiveUsersReport = ->
            event_id = $("#datatable-active-users").attr("js-event-id")
            report_title = $("#datatable-active-users").attr("js-report")
            report_type = $("#datatable-active-users").attr("js-type")
            $.getJSON statURL + "?action=analytics&event_id=" + event_id + "&type=active"
                .done (response) ->
                    if response.length
                        gline = $("#datatable-active-users").DataTable()
                        for i in [0...response[0]['row'].length]
                            gline.row.add([
                                response[0]['row'][i]['source']
                                response[0]['row'][i]['url']
                                response[0]['row'][i]['device']
                                response[0]['row'][i]['city']
                                response[0]['row'][i]['state']
                                response[0]['row'][i]['users']
                            ]).draw false
                        gline.columns.adjust().draw()  
                        traffic_data = []
                        return
            return

        loadTrafficReport = ->
            event_id = $("#datatable-traffic").attr("js-event-id")
            report_title = $("#datatable-traffic").attr("js-report")
            report_type = $("#datatable-traffic").attr("js-type")
            $.getJSON statURL + "?action=analytics&event_id=" + event_id + "&type=" + report_type
                .done (response) ->
                    if response.length
                        gline = $("#datatable-traffic").DataTable()
                        for i in [0...response.length]
                            row_item = []
                            row_item.push response[i][0]
                            row_item.push response[i][1]
                            row_item.push response[i][2].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                            row_item.push response[i][3].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                            row_item.push parseInt(response[i][4]) + "%"
                            row_item.push "$" + parseFloat(response[i][5]).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                            gline.row.add(row_item).draw false
                        gline.columns.adjust().draw()  
                        traffic_data = []
                        if report_type == "gender"
                            traffic_data[2] = packGenderData response, 0, 2, 2
                        else if report_type == "age"
                            traffic_data[2] = packTrafficData response, 0, 2, 5
                        else
                            traffic_data[2] = packTrafficData response, 0, 2, 5
                        drawMorrisDonut "morris-donut-1", traffic_data, "Top " + traffic_data[2].length + " " + report_title
                        return
                    else
                        $("#morris-donut-1").prev().html "No data is available yet" 
            return
        
        packGenderData = (pdata, groupby, sortby, limit) ->
            gdat = []
            gdat.push 
               'label': "male" 
               'value': 0 
            gdat.push 
               'label': "female" 
               'value': 0
            for i in [0...pdata.length]
                if pdata[i][groupby] == "male"
                    gdat[0]["value"] += parseInt pdata[i][sortby]
                if pdata[i][groupby] == "female"
                    gdat[1]["value"] += parseInt pdata[i][sortby]
            return gdat

        descTraffic = (a, b) ->
            if a['value'] < b['value']
                return 1
            if a['value'] > b['value'] 
                return -1
            return 
            
        packTrafficData = (pdata, groupby, sortby, limit) ->
            squish = []
            for i in [0...pdata.length]
               if pdata[i][groupby].toString().includes "/" 
                   slabel = pdata[i][groupby].toString().substring(0, pdata[i][groupby].toString().indexOf(' /'))
               else     
                   slabel = pdata[i][groupby].toString()
               locate = false
               for o in [0...squish.length]
                   if slabel == squish[o]["label"]
                       locate = true
                       squish[o]["value"] += parseInt pdata[i][sortby]
                       break
               if !locate
                   squish.push
                       'label': slabel 
                       'value': parseInt pdata[i][sortby]
            squish.sort descTraffic    
            if squish.length > limit
                squish.slice 0, limit
            return squish 

        ucwords = (str) ->
            (str + '').replace /^([a-z])|\s+([a-z])/g, ($1) ->
                $1.toUpperCase()

        if typeof chartdata != 'undefined'
            if chartdata.length
                if chartdata[0]['data'][2].length
                    drawCharts chartdata
                else
                    $("#date-range").empty()
                    $("#morris-line-1").prev().find("h4").html "No transactions are available to view yet..."

        if $("#dashboard-active-users").length
            loadMainDashActiveUsers null

        if $("#dashboard-session-chart").length
            loadMainDashSessionsGraph null

        if $("#datatable-traffic").length
            loadTrafficReport null

        if $("#datatable-active-users").length
            loadActiveUsersReport null

        if $("[id^=dashboard-summary-]").length
            $("[id^=dashboard-summary-]").each ->
                issued = $(this).attr('js-issued')
                available = $(this).attr('js-available')
                title = $(this).attr('js-title')
                format = $(this).attr('js-format')
                data_table = new Array
                data_table[2] = new Array({
                    'label': 'Issued'
                    'value': issued 
                    },
                    {'label': 'Available'
                    'value': available})
                
                drawMorrisDonut $(this).attr('id'), data_table, title, format 

        if $("[id^=event-summary-]").length
            $("[id^=event-summary-]").each ->
                summary_event = $(this).attr('id').substr($(this).attr('id').indexOf("event-summary-") + 14)
                if summary_event
                    $.getJSON statURL + "?action=event_summary&event_id=" + summary_event
                        .done (response) ->
                            if !response.length
                                response = "<div>No information is available yet for this event yet.</div>"
                            $(response).insertBefore('div#event-summary-'+summary_event)
                            $('div#event-summary-'+summary_event).remove()     


        if $('[id^=datatable]').length
            $.fn.dataTable.moment 'YYYY MMM D h:mm A'
        $('[id^=datatable]').each ->
            sort = if $(this).attr('js-sort') then JSON.parse $(this).attr('js-sort') else [[0, "asc"]] 
            defs = if $(this).attr('js-defs') then JSON.parse $(this).attr('js-defs') else [{"type":"natural-ci", "target":"_all"}] 
            table = $(this).DataTable(
                lengthChange: false
                buttons: [
                    # 'copy'
                    { extend: 'csv', text: 'Export' }
                    # {
                    # extend: 'excelHtml5'
                    # exportOptions: format: body: (data, column, row) ->
                    #     # remove excessive spaces, convert line, strip tags, remove empty lines
                    #     return data.replace(/\t|\s{2,}/g, " ").replace(/<br\s*\/?>/gi, "\u000d\n").replace(/<\/?[^>]+(>|$)/g, "").replace(/^\s*[\r\n]/gm, "")
                    # customize: (xlsx) ->
                    #     # places the dollar sign in American format
                    #     $(xlsx.xl['styles.xml']).find('numFmt[numFmtId="164"]').attr 'formatCode', '[$$-45C] #,##0.00_-'
                    #     return
                    # }
                    # {
                    # extend: 'pdf'
                    # orientation: 'landscape'
                    # pageSize: 'LEGAL'
                    # exportOptions: format: body: (data, column, row) ->
                    #     # remove excessive spaces, convert line, strip tags, remove empty lines
                    #     return data.replace(/\t|\s{2,}/g, " ").replace(/<br\s*\/?>/gi, "\u000d\n").replace(/<\/?[^>]+(>|$)/g, "").replace(/^\s*[\r\n]/gm, "")
                    # }
                    # 'colvis'
                ]
                order: sort
                columnDefs: defs
                lengthMenu: [
                    [25, 50, 100, "All"]
                ])
            table.buttons().container().appendTo '#datatable-buttons_wrapper .col-md-6:eq(0)'
            table.on 'draw.dt', ->
                setupCouponEditorActions()
                return
            return

        if $('form[name=coupon_editor]').length
            setupCouponEditorActions()

        return


    if typeof $().slimscroll != "undefined" && $('body.dashboard').length
        # console.log "dashboard initialized"
        $.AdvancedForm.init()
        dashboard()
    return


# $ ->
#     'use strict'
#     adminAjaxURL = "/admin/dashboard/admin_ajax/"
#     presaleAjaxURL = "/admin/presale/ajax/"
#     broadcastAjaxURL = "/admin/broadcast/ajax/"
#     broadcastServer = "rtmps://5ee24f6c05e7d.streamlock.net"
#
#     AdminDashboard = ->
#         return
#
#     # Dashboard Summary Ajax Load
#     AdminDashboard::initBase = ->
#         # bootstrap confirmation
#         $('[data-toggle=confirmation]').confirmation
#             rootSelector: '[data-toggle=confirmation]'
#             onConfirm: (value) ->
#                 window.location.href = $(this).attr('data-url')
#                 return
#
#         # dropdown lookup lookup
#         $(".bootstrap-select-search").selectpicker()
#         $(".bootstrap-select").selectpicker(
#            liveSearch: false
#         )
#         return
#
#     AdminDashboard::initBroadcastList = ->
#         if $('#admin-broadcast-list').length
#             aquireBroadcasts()
#         return
#
#     AdminDashboard::initDashboardSummary = ->
#         if $('#admin-dashboard-summary').length
#             $daterange = $('[js-admin-order-revenue="revenue"]').find("input")
#             $daterange.on 'dp.change', (e) ->
#                 # console.log "registering date change"
#                 aquireSummary()
#             aquireSummary()
#         return
#
#     AdminDashboard::initPresaleList = ->
#         if $('#admin-presale-list').length
#             aquirePresales()
#         return
#
#     AdminDashboard::init = ->
#         # console.log "initializing admin dashboard"
#         @initBase()
#         @initBroadcastList()
#         @initDashboardSummary()
#         @initPresaleList()
#         return
#
#     $.AdminDashboard = new AdminDashboard
#     $.AdminDashboard.Constructor = AdminDashboard
#
#
#     AdvancedForm = ->
#         @$datetimepicker = false
#         @$datepicker = false
#         return
#
#     AdvancedForm::init = ->
#         if @$datetimepicker
#            @$datetimepicker.each (index) ->
#                 $(this).data("DateTimePicker").destroy()
#                 return
#         if @$datepicker
#            @$datepicker.each (index) ->
#                 $(this).data("DateTimePicker").destroy()
#                 return
#         if $('.bootstrap-datetimepicker').length
#            @$datetimepicker = $('.bootstrap-datetimepicker').datetimepicker
#                 format: "MM/DD/YYYY hh:mm A"
#         if $('.bootstrap-datepicker').length
#             @$datepicker = $('.bootstrap-datepicker').datetimepicker
#                 format: "MM/DD/YYYY"
#         return
#
#     $.AdvancedForm = new AdvancedForm
#     $.AdvancedForm.Constructor = AdvancedForm
#
#     aquireBroadcasts = ->
#         # console.log "running aquireSummary"
#         $('#admin-broadcast-list').replaceWith '<div id="admin-broadcast-list" class="alert-info mt-3 p-4"><div class="spinner" style="margin-top: -31px;"></div>LOADING BROADCASTS!</div>'
#         $.getJSON broadcastAjaxURL + "?action=broadcast_list"
#             .done (response) ->
#                 if !response.length
#                     response = '<div id="admin-broadcast-list" class="alert-info mt-3 p-4"><div>No information is available yet.</div></div>'
#                 # console.log "replacing response"
#                 $('#admin-broadcast-list').replaceWith response
#                 drawDataTable("setupBroadcastActions()")
#             .fail (e) ->
#                 # console.log "aquire failure"
#                 response = '<div id="admin-presale-list" class="alert-info mt-3 p-4"><div>No information is available yet.</div></div>'
#                 $('#admin-broadcast-list').replaceWith response
#
#     aquireSummary = ->
#         # console.log "running aquireSummary"
#         $('#admin-dashboard-summary').replaceWith '<div id="admin-dashboard-summary" class="alert-info mt-3 p-4"><div class="spinner" style="margin-top: -31px;"></div>LOADING ORDERS!</div>'
#         start_date = $("input[name=start_date]").val()
#         end_date = $("input[name=end_date]").val()
#         $.getJSON adminAjaxURL + "?action=order_revenue&start_date=" + start_date + "&end_date=" + end_date
#             .done (response) ->
#                 if !response.length
#                     response = '<div id="admin-dashboard-summary" class="alert-info mt-3 p-4"><div>No information is available yet.</div></div>'
#                 # console.log "replacing response"
#                 $('#admin-dashboard-summary').replaceWith response
#                 drawDataTable()
#             .fail (e) ->
#                 response = '<div id="admin-dashboard-summary" class="alert-info mt-3 p-4"><div>No information is available yet.</div></div>'
#                 $('#admin-dashboard-summary').replaceWith response
#
#     aquirePresales = ->
#         # console.log "running aquireSummary"
#         $('#admin-presale-list').replaceWith '<div id="admin-presale-list" class="alert-info mt-3 p-4"><div class="spinner" style="margin-top: -31px;"></div>LOADING PRESALE CODES!</div>'
#         $.getJSON presaleAjaxURL + "?action=presale_list"
#             .done (response) ->
#                 if !response.length
#                     response = '<div id="admin-presale-list" class="alert-info mt-3 p-4"><div>No information is available yet.</div></div>'
#                 # console.log "replacing response"
#                 $('#admin-presale-list').replaceWith response
#                 drawDataTable("setupPresaleActions()")
#             .fail (e) ->
#                 console.log "aquire failure"
#                 response = '<div id="admin-presale-list" class="alert-info mt-3 p-4"><div>No information is available yet.</div></div>'
#                 $('#admin-presale-list').replaceWith response
#
#     drawDataTable = (cust_func = null) ->
#         $('[id^=datatable]').each ->
#             # console.log $(this).attr('id')
#             sort = if $(this).attr('js-sort') then JSON.parse $(this).attr('js-sort') else [[0, "asc"]]
#             defs = if $(this).attr('js-defs') then JSON.parse $(this).attr('js-defs') else [{"type":"natural-ci", "target":"_all"}]
#             table = $(this).DataTable(
#                 lengthChange: false
#                 buttons: [
#                     'copy'
#                     {
#                     extend: 'excelHtml5'
#                     exportOptions: format: body: (data, column, row) ->
#                         # remove excessive spaces, convert line, strip tags, remove empty lines
#                         return data.replace(/\t|\s{2,}/g, " ").replace(/<br\s*\/?>/gi, "\u000d\n").replace(/<\/?[^>]+(>|$)/g, "").replace(/^\s*[\r\n]/gm, "")
#                     customize: (xlsx) ->
#                         # places the dollar sign in American format
#                         $(xlsx.xl['styles.xml']).find('numFmt[numFmtId="164"]').attr 'formatCode', '[$$-45C] #,##0.00_-'
#                         return
#                     }
#                     # {
#                     # extend: 'pdf'
#                     # orientation: 'landscape'
#                     # pageSize: 'LEGAL'
#                     # exportOptions: format: body: (data, column, row) ->
#                     #     # remove excessive spaces, convert line, strip tags, remove empty lines
#                     #     return data.replace(/\t|\s{2,}/g, " ").replace(/<br\s*\/?>/gi, "\u000d\n").replace(/<\/?[^>]+(>|$)/g, "").replace(/^\s*[\r\n]/gm, "")
#                     # }
#                     'colvis'
#                 ]
#                 order: sort
#                 columnDefs: defs
#                 lengthMenu: [
#                     [25, 50, 100, "All"]
#                 ])
#             table.buttons().container().appendTo '#datatable-buttons_wrapper .col-md-6:eq(0)'
#             if (cust_func)
#                 table.on 'draw.dt', ->
#                     eval(cust_func)
#                     return
#                 eval(cust_func)
#             return
#         return
#
#     repaintServerSource = ->
#         app_name = $('input[name=broadcast_application]').val()
#         if !app_name
#             app_name = "&#60;application name&#62;"
#         $('.server_url').html(broadcastServer + "/" + app_name)
#         return
#
#     setupBroadcastActions = ->
#         $broadcastEditorItem = $("a[data-target='#broadcastEditor']")
#         $broadcastEditorItem.on 'click', (e) ->
#             # console.log "clicked"
#             if $(this).attr('js-event')
#                 # console.log "loading existing"
#                 $('#couponEditorLabel').html("Broadcast Editor")
#                 cei_category = $(this).attr('js-category').split(",")
#                 cei_selected =$('form[name=broadcast_editor] select[name=broadcast_event_id]').val()
#                 $('form[name=broadcast_editor] select[name=broadcast_event_id]').val($(this).attr('js-event')).trigger('change')
#                 $('form[name=broadcast_editor] input[name=broadcast_id]').val($(this).attr('js-broadcast'))
#                 $('form[name=broadcast_editor] select[name=broadcast_active]').val($(this).attr('js-active')).trigger('change')
#                 $('form[name=broadcast_editor] input[name=broadcast_application]').val($(this).attr('js-application'))
#                 $('form[name=broadcast_editor] input[name=broadcast_stream_key]').val($(this).attr('js-key')).trigger('change')
#                 $('form[name=broadcast_editor] input[name=broadcast_source_override]').val($(this).attr('js-override'))
#                 $('form[name=broadcast_editor] input[name=broadcast_tip_url]').val($(this).attr('js-tipurl'))
#                 $('form[name=broadcast_editor] input[name=broadcast_tip_text]').val($(this).attr('js-tiptext'))
#                 cei_showtime = if $(this).attr('js-showtime') == "0000-00-00 00:00:00" then "" else $(this).attr('js-showtime')
#                 $('form[name=broadcast_editor] input[name=broadcast_showtime]').val(cei_showtime)
#                 cei_endtime = if $(this).attr('js-endtime') == "0000-00-00 00:00:00" then "" else $(this).attr('js-endtime')
#                 $('form[name=broadcast_editor] input[name=broadcast_endtime]').val(cei_endtime)
#                 $.AdvancedForm.init()
#                 setTimeout (->
#                     $('form[name=broadcast_editor] select[name=broadcast_category]').selectpicker('val', cei_category)
#                 ), 500
#             else
#                 # console.log "loading new"
#                 $('#couponEditorLabel').html("Create a Broadcast for this Event")
#                 $('form[name=broadcast_editor] input[name=broadcast_id]').val("")
#                 $('form[name=broadcast_editor] select[name=broadcast_event_id]').val("").trigger('change')
#                 $('form[name=broadcast_editor] select[name=broadcast_active]').val(0).trigger('change')
#                 $('form[name=broadcast_editor] input[name=broadcast_application]').val("")
#                 $('form[name=broadcast_editor] input[name=broadcast_stream_key]').val("")
#                 $('form[name=broadcast_editor] input[name=broadcast_source_override]').val("")
#                 $('form[name=broadcast_showtime] input[name=broadcast_showtime]').val("")
#                 $('form[name=broadcast_endtime] input[name=broadcast_endtime]').val("")
#                 $('form[name=broadcast_editor] input[name=broadcast_tip_url]').val("")
#                 $('form[name=broadcast_editor] input[name=broadcast_tip_text]').val("")
#                 $.AdvancedForm.init()
#                 $('form[name=broadcast_editor] select[name=broadcast_category]').val("").trigger('change')
#             return
#
#         $broadcastEventSelector = $("form[name=broadcast_editor] select[name=broadcast_event_id]")
#         $broadcastEventSelector.on 'change', (e) ->
#             ces_selected = $(this).val()
#             $.getJSON broadcastAjaxURL + "?action=category_selector&event_id=" + ces_selected
#                 .done (response) ->
#                     if (response.length)
#                         # console.log response
#                         $('select[name=broadcast_category]').find('option').remove()
#                         for i in [0...response.length]
#                             $('select[name=broadcast_category]').append new Option(response[i]["name"], response[i]["id"])
#                         $('select[name=broadcast_category]').selectpicker('refresh')
#             return
#
#         $broadcastSetApplication = $("form[name=broadcast_editor] input[name=broadcast_application]")
#         $broadcastSetApplication.on 'change', (e) ->
#             repaintServerSource()
#
#         $("[js-button='broadcastEditorSubmit']").on 'click', (e) ->
#             $("input[name=action]").val "save"
#             $("form[name=broadcast_editor]").submit()
#             return
#
#         $("[js-button='broadcastEditorDelete']").on 'click', (e) ->
#             $("[js-button='broadcastEditorClose'").addClass "d-none"
#             $("[js-button='broadcastEditorSubmit'").addClass "d-none"
#             $("[js-button='broadcastEditorDelete'").addClass "d-none"
#             $("[js-button='broadcastEditorCancel'").removeClass "d-none"
#             $("[js-button='broadcastEditorConfirm'").removeClass "d-none"
#             return
#
#         $("[js-button='broadcastEditorCancel']").on 'click', (e) ->
#             $("[js-button='broadcastEditorClose'").removeClass "d-none"
#             $("[js-button='broadcastEditorSubmit'").removeClass "d-none"
#             $("[js-button='broadcastEditorDelete'").removeClass "d-none"
#             $("[js-button='broadcastEditorCancel'").addClass "d-none"
#             $("[js-button='broadcastEditorConfirm'").addClass "d-none"
#             return
#
#         $("[js-button='broadcastEditorConfirm']").on 'click', (e) ->
#             $("input[name=action]").val "delete"
#             $("form[name=broadcast_editor]").submit()
#             return
#
#         return
#
#     setupPresaleActions = ->
#         $presaleEditorItem = $("a[data-target='#presaleEditor']")
#         $presaleEditorItem.on 'click', (e) ->
#             # console.log "clicked"
#             if $(this).attr('js-event')
#                 # console.log "loading existing"
#                 $('#couponEditorLabel').html("Presale Editor")
#                 cei_category = $(this).attr('js-category')
#                 cei_selected =$('form[name=presale_editor] select[name=presale_event_id]').val()
#                 $('form[name=presale_editor] select[name=presale_event_id]').val($(this).attr('js-event')).trigger('change')
#                 $('form[name=presale_editor] input[name=presale_id]').val($(this).attr('js-presale'))
#                 #$('form[name=presale_editor] select[name=presale_category_id]').val($(this).attr('js-category'))
#                 $('form[name=presale_editor] select[name=presale_active]').val($(this).attr('js-active')).trigger('change')
#                 $('form[name=presale_editor] input[name=presale_code]').val($(this).attr('js-code'))
#                 cei_start = if $(this).attr('js-start') == "0000-00-00 00:00:00" then "" else $(this).attr('js-start')
#                 cei_end = if $(this).attr('js-end') == "0000-00-00 00:00:00" then "" else $(this).attr('js-end')
#                 $('form[name=presale_editor] input[name=presale_start_date]').val(cei_start)
#                 $('form[name=presale_editor] input[name=presale_end_date]').val(cei_end)
#                 $.AdvancedForm.init()
#                 setTimeout (->
#                     $('form[name=presale_editor] select[name=presale_category_id]').selectpicker('val', cei_category)
#                 ), 500
#             else
#                 # console.log "loading new"
#                 $('#couponEditorLabel').html("Assign Presale to an Event")
#                 $('form[name=presale_editor] input[name=presale_id]').val("")
#                 $('form[name=presale_editor] select[name=presale_event_id]').val("").trigger('change')
#                 $('form[name=presale_editor] select[name=presale_active]').val(0).trigger('change')
#                 $('form[name=presale_editor] input[name=presale_code]').val("")
#                 $('form[name=presale_editor] input[name=presale_start_date]').val("")
#                 $('form[name=presale_editor] input[name=presale_end_date]').val("")
#                 $.AdvancedForm.init()
#                 $('form[name=presale_editor] select[name=presale_category_id]').val("").trigger('change')
#             return
#
#         $presaleEventSelector = $("form[name=presale_editor] select[name=presale_event_id]")
#         $presaleEventSelector.on 'change', (e) ->
#             ces_selected = $(this).val()
#             $.getJSON presaleAjaxURL + "?action=category_selector&event_id=" + ces_selected
#                 .done (response) ->
#                     if (response.length)
#                         # console.log response
#                         $('select[name=presale_category_id]').find('option').remove()
#                         $('select[name=presale_category_id]').append new Option("All Categories", 0)
#                         for i in [0...response.length]
#                             $('select[name=presale_category_id]').append new Option(response[i]["name"], response[i]["id"])
#                         $('select[name=presale_category_id]').selectpicker('refresh')
#             return
#
#         $("[js-button='presaleEditorSubmit']").on 'click', (e) ->
#             $("input[name=action]").val "save"
#             $("form[name=presale_editor]").submit()
#             return
#
#         $("[js-button='presaleEditorDelete']").on 'click', (e) ->
#             $("[js-button='presaleEditorClose'").addClass "d-none"
#             $("[js-button='presaleEditorSubmit'").addClass "d-none"
#             $("[js-button='presaleEditorDelete'").addClass "d-none"
#             $("[js-button='presaleEditorCancel'").removeClass "d-none"
#             $("[js-button='presaleEditorConfirm'").removeClass "d-none"
#             return
#
#         $("[js-button='presaleEditorCancel']").on 'click', (e) ->
#             $("[js-button='presaleEditorClose'").removeClass "d-none"
#             $("[js-button='presaleEditorSubmit'").removeClass "d-none"
#             $("[js-button='presaleEditorDelete'").removeClass "d-none"
#             $("[js-button='presaleEditorCancel'").addClass "d-none"
#             $("[js-button='presaleEditorConfirm'").addClass "d-none"
#             return
#
#         $("[js-button='presaleEditorConfirm']").on 'click', (e) ->
#             $("input[name=action]").val "delete"
#             $("form[name=presale_editor]").submit()
#             return
#
#         return
#
#     if typeof $().slimscroll != "undefined" && $('body.admin-dash').length
#         # console.log "admin initialized"
#         $.AdvancedForm.init()
#         $.AdminDashboard.init()
#
#
#     # console.log "admin dash code loaded"
#     return
#

$ ->
    'use strict'

    authURL = "/account/ajax"

    ShowTime = ->
        return

    ShowTime::initStream = ->
        # aquire authorization
        showAuth = getShowAuth()

    ShowTime::init = ->
        @initStream()
        # document.addEventListener 'DOMContentLoaded', @initStream()
        return

    getShowAuth = ->
        streamCode = $('#tomatoplayer').attr 'js-auth'
        if streamCode.length
            # Get CSRF token and merge with data
            csrfToken = utility.getCsrfToken()
            ajaxData = $.extend({code: streamCode}, csrfToken)
            $.ajax
                url: authURL
                data: ajaxData
                method: 'post'
                dataType: 'json'
                success: (response)->
                    # no valid reponse returned
                    if (!response.broadcast)
                        $('#video-clock').html("We're sorry, but the code you entered is invalid.  Please try again.")
                        $('#form-code').removeClass("d-none").addClass("d-flex")
                        return

                    # start countdown
                    initCountdown(response)
                    
                    # start loading player
                    initTomatoPlayer(response)
               error: (response)->
                    $('#video-clock').html("There was an issue connecting with the server to confirm your purchase.  Please confirm your Internet connection and try refreshing this page.")
        return

    initCountdown = (showAuth) ->
        $("#event-name").html  showAuth['event_name']
        if showAuth['showtime'].length
            showtimeMoment = moment(showAuth['showtime'], "YYYY/MM/DD HH:mm:ss")
            showtime = showtimeMoment.toDate()
            $('#video-clock').countdown(showtime).on('update.countdown', (event) ->
                $this = $(this).html(event.strftime('' + '<div class="holder m-2"><span class="display-3 font-weight-bold">%D</span> Day%!d</div>' + '<div class="holder m-2"><span class="display-3 font-weight-bold">%H</span> Hr</div>' + '<div class="holder m-2"><span class="display-3 font-weight-bold">%M</span> Min</div>' + '<div class="holder m-2"><span class="display-3 font-weight-bold">%S</span> Sec</div>'))
                return
            ).on 'finish.countdown', (event) ->
                $(this).html('loading . . . ').parent().addClass 'disabled'
                return
        return

    initTomatoPlayer = (showAuth) ->
       
       if checkDate(showAuth, 'endtime')
            setTimeout (->
                $('#video-clock').html("We're sorry!  It looks like this event has ended.")
                return
            ), 5000
            return

        if checkDate(showAuth, 'showtime')
            setTimeout (->
                initTomatoPlayer(showAuth)
                return
            ), 15000
            return

       # set options
        options =
            plugins: httpSourceSelector: default: 'auto'
            youtube:
                ytControls: 2
                playsinline: 1
                modestbranding: 1
                iv_load_policy: 3
                rel: 0
            errorDisplay: false
            controls: true
            fluid: true
            preload: 'auto'
            autoplay: false
            techOrder: [
                'chromecast'
                'html5'
                'youtube'
            ]
            html5: hls: overrideNative: !videojs.browser.IS_ANY_SAFARI

        if isYoutubeLink(showAuth['broadcast'])
            options['controls'] = false
            options['children'] = ['MediaLoader']

        # load player
        window.videojs = videojs
        player = window.player = videojs('tomatoplayer', options)
        # load plugins
        player.httpSourceSelector()
        player.chromecast()

        player.src
            type: 'video/youtube'
            src: showAuth['broadcast']

        if isYoutubeLink(showAuth['broadcast'])
            player.src['type'] = 'video/youtube'

        player.controls true

        player.on 'error', ->
            # console.log player.error()
            if ! checkDate(showAuth, 'expires')
                window.videojs = undefined
                window.player = undefined
                player = undefined
                setTimeout (->
                    initTomatoPlayer(showAuth)
                    return
                ), 15000
            else
                $('#video-clock').html("We're sorry!  It looks like this event has ended.")
                return

        player.ready ->
            @on 'loadedmetadata', ->
                # console.log "this can play"
                $('#event-name').addClass 'hide-video'
                $('#clock-display').addClass 'hide-video'
                if showAuth['tip_url'].length
                    $('#vid-player-links a').attr('href', showAuth['tip_url'])
                    $('#vid-player-links a button').html showAuth['tip_text']
                    $('#vid-player-links').removeClass 'hide-video'

                # check in ticket
                checkIn(showAuth)
                return

            @on 'ended', ->
                # console.log "the video has ended"
                return

            return

        
        return

    checkDate = (showAuth, strict = 'expires') ->
        if strict == "endtime"
            if showAuth['endtime'].length
               endtimeMoment = moment(showAuth['endtime'], "YYYY/MM/DD HH:mm:ss")
               endtime = endtimeMoment.unix()
               if  endtime > 0 && endtime < moment().unix()
                   return true

        if strict == "expires"
            if showAuth['showtime'].length
               showtimeMoment = moment(showAuth['showtime'], "YYYY/MM/DD HH:mm:ss")
               endtime = showtimeMoment.unix() + 7200
               if  endtime < moment().unix()
                   return true

        # start streaming live show 5 minutes before
        if showAuth['broadcast'].match(/\/live\//gi)
            early = 300
        else
            early = 0

        if strict == "showtime"
            if showAuth['showtime'].length
               showtimeMoment = moment(showAuth['showtime'], "YYYY/MM/DD HH:mm:ss")
               starttime = showtimeMoment.unix() - early
               if  starttime > moment().unix()
                   return true

        return false

    checkIn = (showAuth) ->
        if showAuth['barcode'].length
            # Get CSRF token and merge with data
            csrfToken = utility.getCsrfToken()
            ajaxData = $.extend({barcode: showAuth['barcode']}, csrfToken)
            $.ajax
                url: authURL
                data: ajaxData
                method: 'post'
                dataType: 'json'
                success: (response)->
                    # do nothing
                    return
        return

    isYoutubeLink = (ylink) ->
        p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
        if ylink.match(p)
            return true
        else
            return false

    $.ShowTime = new ShowTime
    $.ShowTime.Constructor = ShowTime

    if $('#tomatoplayer').length
       $.ShowTime.init()

    return

$ ->
    testimonialSlider = ->
        slider = $(".testimonial-slider")
        if slider.length > 0
            slider.slick
                infinite: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 5000,
                dots: true,
                prevArrow:"<img class='a-left control-c prev slick-prev' src='/assets/images/ui/thin-arrow-left.png'>",
                nextArrow:"<img class='a-right control-c next slick-next' src='/assets/images/ui/thin-arrow-right.png'>"
    $(document).ready testimonialSlider()
$ ->
    $tomatoFormTogglerButton = $('.tf-toggler-button.tomato-form-toggler-button')

    if $tomatoFormTogglerButton.length > 0
        setAccordionFormStyles = ->
            $tomatoFormTogglerButton.each (i) ->
                $tomatoContainer = $(this).next()
                $tomatoRow = $tomatoContainer.children ":first"
                newClass = "form-big-container-" + i
                auxStyleTomatoForm = document.createElement('style')
                auxStyleTomatoForm.type = 'text/css'
                $(auxStyleTomatoForm).attr("name", newClass)
                auxStyleTomatoForm.innerHTML = '.big-tomato-form-step.show-details .form-big-container.'  + newClass + ' { height: ' + $tomatoRow.height() + 'px; }'
                if $('[name="' + newClass + '"]').length > 0
                    document.getElementsByTagName("head")[0].removeChild $('[name="' + newClass + '"]')[0]
                document.getElementsByTagName("head")[0].appendChild(auxStyleTomatoForm)
                $tomatoContainer.addClass newClass
        setAccordionFormStyles()
        window.utility["setAccordionFormStyles"] = () -> setAccordionFormStyles()
        $(window).on("resize",setAccordionFormStyles)
        $tomatoFormTogglerButton.on 'click', (event) ->
            event.preventDefault()
            if $(this).parent().hasClass 'show-details'
                $($(this).parent()).find('.show-details .toggler-button').trigger 'click'
                $(this).parent().removeClass 'show-details'
                setAccordionFormStyles()
            else
                $(this).parent().toggleClass 'show-details'
            
    $cartFormTogglerButton = $('.toggler-button.cart-toggler-button')
    
    if $cartFormTogglerButton.length > 0
        setAccordionCartStyles = ->
            $cartFormTogglerButton.each (i) ->
                $cartInfoContainer = $(this).prev().children ":last"
                $cartDetailRow = $cartInfoContainer.children ":first"
                newClass = "event-editor-" + i
                auxStyleCartRow = document.createElement('style')
                auxStyleCartRow.type = 'text/css'
                $(auxStyleCartRow).attr("name", newClass)
                auxStyleCartRow.innerHTML = '.cart-row.show-details .event-editor.'  + newClass + ' { height: ' + $cartDetailRow.height() + 'px; }'
                if $('[name="' + newClass + '"]').length > 0
                    document.getElementsByTagName("head")[0].removeChild $('[name="' + newClass + '"]')[0]
                document.getElementsByTagName("head")[0].appendChild(auxStyleCartRow)
                $cartInfoContainer.addClass newClass
                ### $("html, body").animate
                    scrollTop: $cartInfoContainer.parent().offset().top - 200
                , 300 ###
        setAccordionCartStyles()
        $(window).on("resize",setAccordionCartStyles)
        $cartFormTogglerButton.on 'click', (event) ->
            event.preventDefault()
            $(this).parent('.cart-row').toggleClass 'show-details'
            if $(this).parents('.big-tomato-form-step').length > 0
                setTimeout(() ->
                    setAccordionFormStyles()
                , 300)
                
$ ->
    customSelects = $('.tomato-custom-select')

    closeAllCustomSelects = ->
        $(customSelects).find('.select-items').addClass 'select-hide'
        $(customSelects).find('.select-selected').removeClass 'select-arrow-active'

    renderCustomSelects = ->
        if customSelects.length > 0
            customSelects.each (i) ->
                optionKey = undefined
                associatedOptions = undefined
                associatedSelect = undefined
                newSelect = undefined
                newSelectOptionsContainer = undefined
                newSelectOption = undefined
                associatedSelect = $(this).find('select')
                newSelect = document.createElement('div')
                $(newSelect).addClass 'select-selected'
                newSelect.innerHTML = $(associatedSelect).find('option:selected').text()
                $(this).append newSelect
                newSelectOptionsContainer = document.createElement('div')
                $(newSelectOptionsContainer).addClass 'select-items select-hide'
                $(this).append newSelectOptionsContainer
                associatedOptions = $(associatedSelect).find('option')
                optionKey = 0
                while optionKey < associatedOptions.length
                    newSelectOption = document.createElement('div')
                    $(newSelectOption).addClass 'tomato-select-item'
                    newSelectOption.innerHTML = $(associatedOptions[optionKey]).text()
                    $(newSelectOption).attr 'related-value', $(associatedOptions[optionKey]).val()
                    if $(newSelectOption).attr('related-value') == $(associatedSelect).find('option:selected').val()
                        $(newSelectOption).addClass 'same-as-selected'
                    newSelectOption.addEventListener 'click', (e) ->
                        associatedSelect.val $(this).attr('related-value')
                        if !$(this).hasClass('same-as-selected')
                            lastSelected = $(newSelectOptionsContainer).find('.same-as-selected')
                            if lastSelected.length > 0
                                $(lastSelected).removeClass 'same-as-selected'
                            newSelect.innerHTML = $(this).text()
                            $(this).addClass 'same-as-selected'
                            closeAllCustomSelects()
                        associatedSelect.trigger "change"
                    $(newSelectOptionsContainer).append newSelectOption
                    optionKey++
                newSelect.addEventListener 'click', (e) ->
                    e.stopPropagation()
                    newSelectOptionsContainer.classList.toggle 'select-hide'
                    @classList.toggle 'select-arrow-active'
            document.addEventListener 'click', closeAllCustomSelects

    $(document).ready renderCustomSelects()
